window.CurrentAvailableLang =
[
    {
        "LanguageName":"Bahasa Indonesia",
        "code":"id",
        "FlagIcon":"/Assets/images/CountryCode/Indonesia.svg",
    },
    {
        "LanguageName":"English",
        "code":"en",
        "FlagIcon":"/Assets/images/CountryCode/UnitedKingdom.svg",
    }
]


// window["" + window.CurrentCountryID]

window.OptionalTxtid = "Opsional";
window.OptionalTxten = "Optional";

window.NowTxtid = "Sekarang";
window.NowTxten = "Now";

window.AllTxtid = "Semua";
window.AllTxten = "All";

window.ExteriorTxtid = "Eksterior";
window.ExteriorTxten = "Exterior";

window.RoomTxtid = "Kamar";
window.RoomTxtexid = "Kamar";
window.RoomTxten = "Room";
window.RoomTxtexen = "Rooms";

window.FromTxtid = "Mulai dari";
window.FromTxten = "From";

window.MonthTxtid = "Bulan";
window.MonthTxten = "Month";

window.YearTxtid = "Tahun";
window.YearTxten = "Year";

window.NightTxtid = "Malam";
window.NightTxtexid = "Malam";
window.NightTxten = "Night";
window.NightTxtexen = "Nights";

window.OrangTxtid = "Orang";
window.OrangTxten = "Person";

window.SessionTxtid = "Sesi";
window.SessionTxten = "Session";


window.ItemsTxtid = "Item";
window.ItemsTxtexid = "Item";
window.ItemsTxten = "Item";
window.ItemsTxtexen = "Items";


window.NightTextDisplayer = function(value)
{
    if(value > 1)
    {
        return value + " " + window["NightTxtex" + window.CurrentCountryID];
    }
    else
    {
        return value + " " + window["NightTxt" + window.CurrentCountryID];
    }
}

window.PerMalamTxtid = " per Malam";
window.PerMalamTxten = " per Night";

window.PerMalam2Txtid = " / Malam";
window.PerMalam2Txten = " / Night";

window.PerItemTxtid = " / Item";
window.PerItemTxten = " / Item";

window.PerSessionTxtid = " per Sesi";
window.PerSessionTxten = " per session";

window.TypeItemTextDisplayer = function(thistype)
{
    let ValueToReturn = " per <span class='InterExBoldTextFont'>Malam</span>";
    if(thistype == "night" && window.CurrentCountryID == "en")
    {
        ValueToReturn = " / <span class='InterExBoldTextFont'>Night</span>";
    }
    else if(thistype == "item")
    {
        ValueToReturn = " per <span class='InterExBoldTextFont'>Item</span>";
        if(window.CurrentCountryID == "en")
        {
            ValueToReturn = " / <span class='InterExBoldTextFont'>Item</span>";
        }
    }
    return ValueToReturn;
}


window.DayAgoTxtid = "hari lalu";
window.DayAgoTxtexid = "hari lalu";
window.DayAgoTxten = "day ago";
window.DayAgoTxtexen = "days ago";

window.AccommodationTxtid = "Penginapan";
window.AccommodationTxtexid = "Penginapan";
window.AccommodationTxten = "Accommodation";
window.AccommodationTxtexen = "Accommodations";

window.ExperienceTxtid = "Experience";
window.ExperienceTxten = "Experience";

window.HourTxtid = "Jam";
window.HourTxtexid = "Jam";
window.HourTxten = "Hour";
window.HourTxtexen = "Hours";

window.HourAgoTxtid = "jam lalu";
window.HourAgoTxtexid = "jam lalu";
window.HourAgoTxten = "hour ago";
window.HourAgoTxtexen = "hours ago";

window.MinTxtid = "Menit";
window.MinTxtexid = "Menit";
window.MinTxten = "Min";
window.MinTxtexen = "Mins";

window.MinAgoTxtid = "menit lalu";
window.MinAgoTxtexid = "menit lalu";
window.MinAgoTxten = "minute ago";
window.MinAgoTxtexen = "minutes ago";

window.SecTxtid = "Detik";
window.SecTxtexid = "Detik";
window.SecTxten = "Sec";
window.SecTxtexen = "Secs";

window.SecAgoTxtid = "detik lalu";
window.SecAgoTxtexid = "detik lalu";
window.SecAgoTxten = "second ago";
window.SecAgoTxtexen = "seconds ago";

window.UpToTxtid = "Sampai";
window.UpToTxten = "Up to";

window.RatingTxtid = "Rating";
window.RatingTxtexid = "Rating";
window.RatingTxten = "Rating";
window.RatingTxtexen = "Ratings";

window.FacilityTxtid = "Fasilitas";
window.FacilityTxten = "Facility";

window.FilterTxtid = "Filter";
window.FilterTxten = "Filters";

window.ResultForTxt = function(thissearch)
{
    let TextToDisplay = "Results for <span class='InterExBoldTextFont'>“" + thissearch +"”</span>";
    if(window.CurrentCountryID == "id")
        TextToDisplay = "Hasil untuk <span class='InterExBoldTextFont'>“" + thissearch +"”</span>";

    return TextToDisplay;
}

window.MauNginapDimanaTxtid = "Mau Nginap dimana?";
window.MauNginapDimanaTxten = "Where do you want to stay?";

window.MauNginapExploreTxtid = "Mau Explore kemana?";
window.MauNginapExploreTxten = "Where do you want to explore?";

window.DateOfVisitTxtid = "Tanggal Berkunjung";
window.DateOfVisitTxten = "Date of Visit";

window.SelectDateOfVisitTxtid = "Pilih Tanggal Berkunjung";
window.SelectDateOfVisitTxten = "Select Date of Visit";

window.CheckInTxtid = "Check-In";
window.CheckInTxten = "Check-In";

window.SelectCheckInTxtid = "Pilih Check-In";
window.SelectCheckInTxten = "Select Check-In Date";

window.CheckOutTxtid = "Check-Out";
window.CheckOutTxten = "Check-Out";

window.SelectCheckOutTxtid = "Pilih Check-Out";
window.SelectCheckOutTxten = "Select Check-Out Date";

window.CheckInNOutTxtid = "Check-in & Out";
window.CheckInNOutTxten = "Check-in & Out";

window.JumlahKaliPenukaranTxtid = "Penukaran";
window.JumlahKaliPenukaranTxten = "Times";

window.OrTxtid = "atau";
window.OrTxten = "or";

window.YouTxtid = "Anda";
window.YouTxten = "You";

// Social ================================================================================================

window.WhatsAppTxtid = "WhatsApp";
window.WhatsAppTxten = "WhatsApp";
window.WhatsAppNumberTxtid = "Nomor Whatsapp";
window.WhatsAppNumberTxten = "Whatsapp Number";
window.WhatsAppNumberEmptyTxtid = "Nomor WhatsApp tidak boleh kosong!";
window.WhatsAppNumberEmptyTxten = "WhatsApp Number cannot be empty!";

window.InstagramTxtid = "Instagram";
window.InstagramTxten = "Instagram";
window.InstagramEmptyTxtid = "Instagram Tidak Boleh Kosong!";
window.InstagramEmptyTxten = "Instagram cannot be empty!";
window.InstagramPlaceholderTxtid = "Misalnya: https://www.instagram.com/pingingo.official/";
window.InstagramPlaceholderTxten = "e.g. https://www.instagram.com/pingingo.official/";

window.TikTokTxtid = "TikTok";
window.TikTokTxten = "TikTok";
window.TikTokEmptyTxtid = "Link TikTok tidak boleh kosong!";
window.TikTokEmptyTxten = "TikTok Link cannot be empty!";
window.TikTokPlaceholderTxtid = "Misalnya: https://www.tiktok.com/@pingingo.official";
window.TikTokPlaceholderTxten = "e.g. https://www.tiktok.com/@pingingo.official";

window.FacebookTxtid = "Facebook";
window.FacebookTxten = "Facebook";

window.CrowdSharingTxtid = "Crowd Sharing";
window.CrowdSharingTxten = "Crowd Sharing";
window.CrowdSharing2Txtid = "Ping & Share (Crowd Sharing)";
window.CrowdSharing2Txten = "Ping & Share (Crowd Sharing)";

window.PopUpBannerTxtid = "PopUp Banner";
window.PopUpBannerTxten = "PopUp Banner";

window.EmailBlastTxtid = "Email Blast";
window.EmailBlastTxten = "Email Blast";

window.PinginGoBlogTxtid = "PinginGo Blog";
window.PinginGoBlogTxten = "PinginGo Blog";


// Main Sections ================================================================================================

window.MyPingTxtid = "Perjalanan Saya";
window.MyPingTxten = "My Ping";

window.BookingDetailsTxtid = "Detail Pemesanan";
window.BookingDetailsTxten = "Booking Details";

window.ProfileTxtid = "Profil";
window.ProfileTxten = "Profile";

window.UpdateProfileid = "Perbarui Profil";
window.UpdateProfileen = "Update Profile";

window.ReferralTxtid = "Referral";
window.ReferralTxten = "Referral";

window.MyVoucherTxtid = "Voucher Saya";
window.MyVoucherTxten = "My Voucher";

window.VoucherDetailsTxtid = "Detail Voucher";
window.VoucherDetailsTxten = "Voucher Details";

window.SignOutTxtid = "Keluar";
window.SignOutTxten = "Sign Out";



// Sub Sections ================================================================================================

window.AboutUsTxtid = "Tentang Kami";
window.AboutUsTxten = "About Us";

window.ContactUsTxtid = "Hubungi PinginGo";
window.ContactUsTxten = "Contact Us";

window.TermsNConditionTxtid = "Syarat dan Ketentuan";
window.TermsNConditionTxten = "Terms and Conditions";

window.TermsNCondition2Txtid = "Syarat & Ketentuan";
window.TermsNCondition2Txten = "Terms & Conditions";

window.PrivacyTxtid = "Kebijakan Privasi";
window.PrivacyTxten = "Privacy Policy";

window.PernyataanCookieTxtid = "Pernyataan Cookie";
window.PernyataanCookieTxten = "Cookie Statement";

window.FAQTxtid = "Pusat Bantuan";
window.FAQTxten = "FAQ";
window.FAQ2Txtid = "Pusat Bantuan";
window.FAQ2Txten = "Frequently Ask Question";
window.HowCanWeHelpYouTxtid = "Bagaimana kami dapat membantu Anda?";
window.HowCanWeHelpYouTxten = "How can we help you?";

window.PopularQuestionTxtid = "Pertanyaan Populer";
window.PopularQuestionTxten = "Popular Question";

window.InfoTxtid = "Info";
window.InfoTxten = "Info";

window.HowToBookTxtid = "Cara booking di PinginGo";
window.HowToBookTxten = "How to book on PinginGo";

window.ListingYourAccTxtid = "Daftar Jadi Mitra Sekarang";
window.ListingYourAccTxten = "Listing your Accommodation";

window.FollowUsTxtid = "Ikuti Kami";
window.FollowUsTxten = "Follow Us";

window.BlogPinginGoTxtid = "Blog PinginGo";
window.BlogPinginGoTxten = "Blog PinginGo";


// EDIT INFO GUIDE ================================================================================================

window.WelcomeToPinginGoGuideTxtid = function(value){ return "Halo " + value + "!"};
window.WelcomeToPinginGoGuideTxten = function(value){ return "Hello " + value + "!"};

window.EditGuideMessagTxtid = "Selamat datang di PinginGo. Lengkapi profilmu sekarang biar pengalaman makin maksimal!";
window.EditGuideMessagTxten = "Welcome to PinginGo! Click here to complete your profile such as Name and Phone number.";

window.CariKlikBerangkatTxtid = "Cari, Klik, Berangkat!";
window.CariKlikBerangkatTxten = "Search, Click, Go!";

window.LoginWithGooglePopUpMessageTxtid = "<span class='InterBoldTextFont'>Masuk/ Daftar</span> pakai Google biar nggak perlu ketik-ketik lagi. Cukup satu klik buat amankan penginapan impianmu.";
window.LoginWithGooglePopUpMessageTxten = "<span class='InterBoldTextFont'>Sign in/ Register</span> using Google to avoid typing. Just one click to secure your dream accommodation.";



// USER DATA RELATED ================================================================================================

window.YourNameTxtid = "Nama"; // Your Name -----------
window.YourNameTxten = "Your Name";
window.YourNameCannotEmptyTxtid = "Nama Tidak Boleh Kosong!";
window.YourNameCannotEmptyTxten = "Name cannot be Empty!";

window.FirstNameTxtid = "Nama depan"; // First Name -----------
window.FirstNameTxten = "First Name";
window.InputFirstNamePlaceholderid = "Masukkan Nama Depan";
window.InputFirstNamePlaceholderen = "Input First Name";
window.FirstNameCannotEmptyid = "Nama Depan Tidak Boleh Kosong!";
window.FirstNameCannotEmptyen = "First Name cannot be Empty!";

window.LastNameTxtid = "Nama Belakang"; // Last Name -----------
window.LastNameTxten = "Last Name";
window.InputLastNamePlaceholderid = "Masukkan Nama Belakang";
window.InputLastNamePlaceholderen = "Input Last Name";

window.FullNameTxtid = "Nama Lengkap"; // Full Name -----------
window.FullNameTxten = "Full Name";
window.InputFullNamePlaceholderTxtid = "Masukkan Nama Lengkap";
window.InputFullNamePlaceholderTxten = "Input Full Name";
window.FullNameCannotEmptyTxtid = "Nama Lengkap Tidak Boleh Kosong!";
window.FullNameCannotEmptyTxten = "Full Name cannot be Empty!";

window.GenderHeaderTxtid = "Jenis kelamin"; // Gender -----------
window.GenderHeaderTxten = "Gender";
window.GenderMaleTxtid = "Laki-Laki";
window.GenderMaleTxten = "Male";
window.GenderFemaleTxtid = "Perempuan";
window.GenderFemaleTxten = "Female";

window.GenderChoicesJSON =
[
    {
        "which_type":"Male",
        "translation": "GenderMaleTxt"
    },
    {
        "which_type":"Female",
        "translation": "GenderFemaleTxt"
    },
];

window.PhoneNumberHeaderTxtid = "Nomor Telepon"; // Phone Number -----------
window.PhoneNumberHeaderTxten = "Phone Number";
window.PhoneNumberCannotEmptyid = "Nomor Telepon tidak Boleh Kosong!";
window.PhoneNumberCannotEmptyen = "Phone Number cannot be Empty!";
window.PhoneNumberAlreadyUsedTxtid = "Nomor Telepon Sudah Digunakan!";
window.PhoneNumberAlreadyUsedTxten = "Phone Number Already Used!";
window.PhoneNumberInvalidTxtid = "Nomor Telepon Tidak Valid!";
window.PhoneNumberInvalidTxten = "Phone Number Invalid!";

window.CountryHeaderTxtid = "Negara"; // Country -----------
window.CountryHeaderTxten = "Country";

window.IDCardHeaderTxtid = "Nomor KTP"; // ID Card -----------
window.IDCardHeaderTxten = "ID Card";
window.IDCardInputPlaceholderid = "Masukkan Kartu Identitas Anda";
window.IDCardInputPlaceholderen = "Enter your ID Card";
window.IDCardCannotEmptyid = "Kartu Identitas Tidak Boleh Kosong!";
window.IDCardCannotEmptyen = "ID Card cannot be Empty!";
window.IDCardCannotBeUsedid = "Kartu Identitas tidak dapat digunakan!";
window.IDCardCannotBeUseden = "ID Card cannot be Used!";
window.IDCardAlreadyUsedTxtid = "Kartu Identitas sudah digunakan!";
window.IDCardAlreadyUsedTxten = "ID Card already Used!";

window.IDCardPassportTxtid = "Nomor Identitas"; // ID Card/ Passport -----------
window.IDCardPassportTxten = "ID Card/ Passport";
window.IDCardPassportInputPlaceholderTxtid = "Misalnya: 12345678910";
window.IDCardPassportInputPlaceholderTxten = "e.g.: 12345678910";

window.ReferralIDid = "ID Referral"; // Referral -----------
window.ReferralIDen = "Referral ID";
window.ReferralIDInputPlaceholderid = "Masukkan Kode Referral Anda";
window.ReferralIDInputPlaceholderen = "Enter your Referral ID";

window.EmailTxtid = "E-mail"; // Email -----------
window.EmailTxten = "Email";
window.EmailAddressTxtid = "Alamat Email";
window.EmailAddressTxten = "Email Address";
window.SampleEmailPlaceholderid = "Misalnya: test@gmail.com";
window.SampleEmailPlaceholderen = "e.g.: test@gmail.com";
window.InputEmailPlaceholderid = "Masukkan Alamat Email Anda";
window.InputEmailPlaceholderen = "Input your Email Address";
window.EmailCannotEmptyid = "E-mail Tidak Bisa Kosong!";
window.EmailCannotEmptyen = "Email cannot be Empty!";
window.InvalidEmailFormatMesid = "<span class='InterBoldTextFont'>Format Email salah</span>, cek Email anda atau coba lagi";
window.InvalidEmailFormatMesen = "Invalid Email Format!";
window.EmailAlreadyUsedid = "Email Sudah Digunakan!";
window.EmailAlreadyUseden = "Email Already Used!";

window.PasswordHeaderTextid = "Kata Sandi"; // Password -----------
window.PasswordHeaderTexten= "Password";
window.InputPassPlaceholderid = "Masukkan Kata Sandi Email Anda";
window.InputPassPlaceholderen = "Input your Email Password";
window.PasswordCannotBeEmptyTxtid = "Kata Sandi Tidak Boleh Kosong!";
window.PasswordCannotBeEmptyTxten = "Password cannot be Empty!";

window.NewPasswordPlaceholderTxtid = "Masukkan Kata Sandi Baru Anda";
window.NewPasswordPlaceholderTxten = "Input your New Password";
window.NewPasswordCannotBeEmptyid = "Kata Sandi Baru Tidak Boleh Kosong!";
window.NewPasswordCannotBeEmptyen = "New Password cannot be Empty!";

window.ReenterPasswordHeaderTextid = "Ulangi Password";
window.ReenterPasswordHeaderTexten= "Re-type Password";
window.ReenterPasswordPlaceholderTxtid = "Ketik ulang Kata Sandi yang Anda masukkan";
window.ReenterPasswordPlaceholderTxten = "Re-Type your inputted Password";

window.ConfirmPasswordEmptyTextid = "Konfirmasi Kata Sandi Tidak Boleh Kosong!";
window.ConfirmPasswordEmptyTexten = "Confirm Password cannot be Empty!";
window.ConfirmPasswordNotSameid = "Konfirmasi Kata Sandi harus sama dengan Kata Sandi Baru!";
window.ConfirmPasswordNotSameen = "Confirm Password must be same as New Password!";

window.MinPassWarningid = "Jumlah Karakter Minimal " + window.MinimalPasswordCharacter;
window.MinPassWarningen = "Minimum Number of Characters is " + window.MinimalPasswordCharacter;
window.MinPassWarningTxt2id = "Kolom kata sandi baru harus terdiri minimal " + window.MinimalPasswordCharacter + " karakter.";
window.MinPassWarningTxt2en = "The new password field must be at least " + window.MinimalPasswordCharacter + " characters.";
window.PassNotStrongid = "Kata Sandi Tidak Cukup Kuat";
window.PassNotStrongen = "Password Not Stong Enough";
window.WrongPasswordTxtid = "Kata sandi atau email salah";
window.WrongPasswordTxten = "Wrong password or email";

window.ForgotPasswordTxtid = "Lupa Kata Sandi";
window.ForgotPasswordTxten = "Forgot Password";

window.AlamatTxtid = "Alamat"; // Alamat -----------
window.AlamatTxten = "Address";

window.CompanyTxtid = "Perusahaan"; // Company -----------
window.CompanyTxten = "Company";
window.CompanyCannotEmptyTxtid = "Nama Perusahaan Tidak Boleh Kosong!";
window.CompanyCannotEmptyTxten = "Company Name cannot be Empty!";

window.MessageTxtid = "Pesan"; // Message -----------
window.MessageTxten = "Message";
window.MessageCannotEmptyTxtid = "Pesan Tidak Bisa Kosong!";
window.MessageCannotEmptyTxten = "Message cannot be Empty!";
window.InputMessageContactUsPlaceHolderTxtid = "Hai, saya tertarik dengan PinginGo.";
window.InputMessageContactUsPlaceHolderTxten = "Hi, Im Interest with PinginGo";

window.SaveProfileBtnTxtid = "Simpan Profil";
window.SaveProfileBtnTxten = "Save Profile";

window.SmokingRoomTxtid = "Tempat Merokok";
window.SmokingRoomTxten = "Smoking Room";

window.NonSmokingRoomTxtid = "Bebas Asap Rokok";
window.NonSmokingRoomTxten = "Non Smoking Room";

window.RoomPreferencesTxt = function(value)
{
    if(value == "Non Smoking Room")
    {
        return window["NonSmokingRoomTxt" + window.CurrentCountryID];
    }
    else
    {
        return window["SmokingRoomTxt" + window.CurrentCountryID];
    }
}

window.TranslatedRoomStatusTxt =
[
    {
        "status":"Booking Confirmed",
        "text_lang":
        {
            "id":"Pemesanan Dikonfirmasi",
            "en":"Booking Confirmed"
        },
    },
    {
        "status":"Booking Completed",
        "text_lang":
        {
            "id":"Pemesanan Berhasil",
            "en":"Booking Completed"
        },
    },
    {
        "status":"Booking Fee Paid",
        "text_lang":
        {
            "id":"Uang Muka Dibayar",
            "en":"Booking Fee Paid"
        },
    },
    {
        "status":"Progress",
        "text_lang":
        {
            "id":"Uang Muka Dibayar",
            "en":"Booking Fee Paid"
        },
    },
    {
        "status":"Check-in",
        "text_lang":
        {
            "id":"Sudah check-in",
            "en":"Checked-in"
        },
    },
    {
        "status":"Booking Payment Canceled",
        "text_lang":
        {
            "id":"Pembayaran Dibatalkan",
            "en":"Booking Payment Canceled"
        },
    },
    {
        "status":"Booking Canceled",
        "text_lang":
        {
            "id":"Pemesanan Dibatalkan",
            "en":"Booking Canceled"
        },
    },
    {
        "status":"Booking Payment on Progress",
        "text_lang":
        {
            "id":"Menunggu Pembayaran",
            "en":"Booking Payment on Progress"
        },
    },
    {
        "status":"Waiting Payment",
        "text_lang":
        {
            "id":"Menunggu Pembayaran",
            "en":"Waiting Payment"
        },
    },
    {
        "status":"No Booking Payment",
        "text_lang":
        {
            "id":"Belum Ada Pembayaran",
            "en":"No Booking Payment"
        },
    },
    {
        "status":"Waiting for Confirmation",
        "text_lang":
        {
            "id":"Menunggu Konfirmasi",
            "en":"Waiting for Confirmation"
        },
    },
    {
        "status":"Waiting Payment Confirmation",
        "text_lang":
        {
            "id":"Menunggu Konfirmasi Pembayaran",
            "en":"Waiting Payment Confirmation",
        },
    },
    {
        "status":"Booking Payment Timeout",
        "text_lang":
        {
            "id":"Batas Waktu Pembayaran Habis",
            "en":"Booking Payment Timeout"
        },
    },
    {
        "status":"Booking Timeout",
        "text_lang":
        {
            "id":"Batas Waktu Pembayaran Habis",
            "en":"Booking Timeout"
        },
    }
];

window.MetodePembayaranBelumDipilihTxtid = "Metode pembayaran belum dipilih";
window.MetodePembayaranBelumDipilihTxten = "Payment Method Not Selected";

window.StatusPaidTxtid = "Sudah Dibayar";
window.StatusPaidTxten = "Paid";


// COMMON BUTTONS OR BASIC UI ================================================================================================

window.SearchTxtid = "Cari";
window.SearchTxten = "Search";

window.SearchRoomsTxtid = "Cari Penginapan";
window.SearchRoomsTxten = "Search Accommodation";

window.SearchExperiencesTxtid = "Cari Experience";
window.SearchExperiencesTxten = "Search Experience";

window.ContinueTxtid = "Lanjutkan"; // Continue 
window.ContinueTxten= "Continue";

window.ContinueTxt2id = "Lanjut"; // Continue 2
window.ContinueTxt2en= "Continue";

window.CancelTxtid = "Batal"; // Cancel 
window.CancelTxten = "Cancel";

window.CloseButtonTxtid = "Tutup"; // Close 
window.CloseButtonTxten = "Close";

window.ChangeButtonTxtid = "Ubah"; // Change 
window.ChangeButtonTxten = "Change";

window.BackTxtid = "Kembali"; // Back 
window.BackTxten= "Back";

window.SelesaiTxtid = "Selesai"; // Selesai 
window.SelesaiTxten= "Done";

window.SavedButtonTxtid = "Simpan"; // Save
window.SavedButtonTxten = "Save";

window.LihatKamarButtonTxtid = "Lihat Kamar"; // Lihat Kamar
window.LihatKamarButtonTxten = "View Room";

window.EditButtonTxtid = "Ubah"; // Edit
window.EditButtonTxten = "Edit";

window.TukarRewardTxtid = "Tukar Reward"; // Tukar Rewards
window.TukarRewardTxten = "Exchange Rewards";

window.SetuplaterTextid = "Atur Nanti"; // Set Up Later 
window.SetuplaterTexten = "Set-Up Later";

window.ExplorePinginGoTextid = "Explore Sekarang"; // Explore PinginGo 
window.ExplorePinginGoTexten = "Explore PinginGo";

window.ExploreMoreTxtid = "Jelajahi Lebih Lanjut"; // Explore More 
window.ExploreMoreTxten = "Explore More";

window.ListingYourAccBtnTextid = "Daftar Jadi Mitra Sekarang"; // List Your Acc -------------
window.ListingYourAccBtnTexten = "Listing your Accommodation";

window.ListingYourAccBtnTextSrtid = "Jadi Mitra"; // List Your Acc Short -------------
window.ListingYourAccBtnTextSrten = "Become a Partner";

window.LoginBtnTextid = "Masuk"; // Sign In 
window.LoginBtnTexten = "Sign In";

window.RegisterBtnTextid = "Daftar"; // Register 
window.RegisterBtnTexten = "Register";

window.ReadMoreBtnTextid = "Selengkapnya"; // Read More 
window.ReadMoreBtnTexten = "Read more";

window.ContinueWithEmailTxtid = "Lanjutkan dengan Email"; // Continue with Email 
window.ContinueWithEmailTxten = "Continue with Email";

window.ResendEmailBtnTxtid = "Kirim Ulang Email"; // Resend Email
window.ResendEmailBtnTxten = "Resend Email";

window.ChangeEmailBtnTxtid = "Ubah Alamat Email"; // Change Email
window.ChangeEmailBtnTxten = "Change Email Address";

window.CopyTxtid = "Salin";
window.CopyTxten = "Copy";

window.LoadMoreTxtid = "Lihat Lainnya";
window.LoadMoreTxten = "Load More";

window.SendMessageButtonTxtid = "Kirim Pesan";
window.SendMessageButtonTxten = "Send Message";

window.ChatOnWhatsAppButtonTxtid = "Kirim Pesan via WhatsApp";
window.ChatOnWhatsAppButtonTxten = "Chat on WhatsApp";

//???????????????
window.SignInwithPhoneTxtid = "Masuk dengan Nomor Telepon"; // Sign In Use Phone
window.SignInwithPhoneTxten = "Sign in with Phone";
//???????????????

window.SignInwithGoogleTxtid = "Masuk Dengan Google"; // Sign In Use Phone
window.SignInwithGoogleTxten = "Sign in with Google";

window.NextBtnTxtid = "Berikutnya"; // Next
window.NextBtnTxten = "Next";

window.TotalTxtid = "Jumlah"; // Total
window.TotalTxten = "Total";

window.TotalTxt2id = "Total";
window.TotalTxt2en = "Total";

window.JumlahTamuTxtid = "Jumlah Tamu <span style=\"color: #c10000\">*</span>";
window.JumlahTamuTxten = "Total Guest <span style=\"color: #c10000\">*</span>";

window.JumlahTamuTxt2id = "Jumlah Tamu";
window.JumlahTamuTxt2en = "Total Guest";

window.UbahJumlahTamuTxtid = "Ubah Jumlah Tamu";
window.UbahJumlahTamuTxten = "Change Total Guest";


window.TotalHargaTxtid = "Total Harga"; // Harga
window.TotalHargaTxten = "Total Price";

window.SeeMapTxtid = "Lihat Peta"; // See Map
window.SeeMapTxten = "See Map";

window.TambahkanTxtid = "Tambahkan"; // Tambahkan
window.TambahkanTxten = "Add";

window.DitambahkanTxtid = "Ditambahkan";
window.DitambahkanTxten = "Added";

window.HargaTiketMasukOrangDewasaTxtid = "Harga tiket masuk dewasa";
window.HargaTiketMasukOrangDewasaTxten = "Adult entrance ticket price"

window.CannotAddAddOnDueToAmountInputTxtid = "Tidak dapat menambahkan add-on karena jumlah input yang ditentukan 0";
window.CannotAddAddOnDueToAmountInputTxten = "Cannot Add Add-On Due to Amount Input is 0";

window.AddOnCanOnlyMinimum = function(input)
{
    let ErrorToReturn = "The minimum quantity for this add-on is " + input + ".";

    if(window.CurrentCountryID == "id")
        ErrorToReturn = "Jumlah minimum untuk add-on ini adalah " + input + ".";

    return  ErrorToReturn;
}

window.AddOnCanOnlyMaximum = function(input)
{
    let ErrorToReturn = "The maximum quantity for this add-on is " + input + ".";
    
    if(window.CurrentCountryID == "id")
        ErrorToReturn = "Jumlah maksimum untuk add-on ini adalah " + input + ".";

    return  ErrorToReturn;
}

window.TicketFreeFor5YearsTxtid = "<span class='InterExBoldTextFont'>Gratis</span> untuk anak dibawah 5 tahun";
window.TicketFreeFor5YearsTxten = "<span class='InterExBoldTextFont'>Free</span> for children under 5 years";

window.ShareTxtid = "Bagikan"; // Share
window.ShareTxten = "Share";

window.SelectRoomButtonTxtid = "Pilih Kamar";
window.SelectRoomButtonTxten = "Select Room";

window.SelectExperienceTxtid = "Pilih Experience";
window.SelectExperienceTxten = "Select Experience";

window.SelectRoomItemButtonTxtid = "Pilih Kamar / Item";
window.SelectRoomItemButtonTxten = "Select Room / Item";

window.SelectedButtonTxtid = "Dipilih";
window.SelectedButtonTxten = "Selected";

window.ChangeDateSettingsTxtid = "Ubah Tanggal";
window.ChangeDateSettingsTxten = "Change Settings";

window.ExpandBtnTxtid = "Perbesar";
window.ExpandBtnTxten = "Expand";

window.PingNowBtnTxtid = "Booking Sekarang";
window.PingNowBtnTxten = "Ping Now";

window.DapatkanRefMessageTxtid = "Dapatkan Referral Poin setelah teman kamu menginap";
window.DapatkanRefMessageTxten = "Earn Referral Points after your friend stays";

window.ChooseRoomsTxtid = "Pilih Akomodasi";
window.ChooseRoomsTxten = "Select Accommodation";

window.ChooseExperiencesTxtid = "Pilih Experience";
window.ChooseExperiencesTxten = "Select Experience";

window.ShareThisPingTxtid = "Bagikan Booking";
window.ShareThisPingTxten = "Share Booking";

window.ShareThisPingTxt2id = "Bagikan Booking ini";
window.ShareThisPingTxt2en = "Share this Booking";

window.ShareBookingSuccessTxtid = "Booking Berhasil Dibagikan";
window.ShareBookingSuccessTxten = "Share Booking Success";


window.ShareAccommodationTxtid = "Bagikan Penginapan";
window.ShareAccommodationTxten = "Share Accommodation";

window.ShareThisAccommodationTxt2id = "Bagikan Penginapans ini";
window.ShareThisAccommodationTxt2en = "Share this Accommodation";

window.ShareAccommodationSuccessTxtid = "Penginapan Berhasil Dibagikan";
window.ShareAccommodationSuccessTxten = "Share Accommodation Success";


window.SeeDetailsBtnTxtid = "Lihat Rincian";
window.SeeDetailsBtnTxten = "See Details";

window.VerifyBtnTxtid = "Verifikasi";
window.VerifyBtnTxten = "Verify";

window.ExploreTxtid = "Jelajahi";
window.ExploreTxten = "Explore";

window.RemovePhotoTxtid = "Hapus Foto";
window.RemovePhotoTxten = "Remove Photo";

window.AddPhotoToYourExperiencesButtonTxtid = "Tambahkan FotoTambahkan Foto ke Pengalamanmu 📸";
window.AddPhotoToYourExperiencesButtonTxten = "Add Photo to your experiences";

window.SubmitExperienceButtonTxtid = "Bagikan Pengalaman";
window.SubmitExperienceButtonTxten = "Submit Experience";

window.CopyClipboardSuccessTxtid = "Teks Berhasil Disalin";
window.CopyClipboardSuccessTxten = "Copied to Clipboard Successfully";

window.ApplyTxtid = "Simpan";
window.ApplyTxten = "Apply";

window.ShareReferralTxtid = "Bagikan Kode Referral";
window.ShareReferralTxten = "Share Referral";

window.ChooseExperienceTypeTxtid = "Pilih Jenis Experience";
window.ChooseExperienceTypeTxten = "Select Experience Type";

window.TipeExperienceTxtid = "Tipe Experience";
window.TipeExperienceTxten = "Experience Type";

// HERO AND FOOTER ================================================================================================

window.HeroBannerTextid = "Temukan <span class=\"InterBoldTextFont\">Pengalaman</span> dan <span class=\"InterBoldTextFont\">Penginapan Unik</span> di Indonesia<br>Hanya di <span class=\"InterBoldTextFont\">PinginGo</span>";
window.HeroBannerTexten = "More Ping & Share, Endless Experiences";

window.FooterBannerTextid = "Menginap <span class=\"InterBoldTextFont\">Nyaman</span>, <span class=\"InterBoldTextFont\">Pengalaman</span> Tak Terlupakan";
window.FooterBannerTexten = "More Ping & Share, Endless Experiences";

window.ForeMostFooterBelowTextid = "More Ping and Share, Endless Experience";
window.ForeMostFooterBelowTexten = "More Ping and Share, Endless Experience";



// ERROR MESSAGES ================================================================================================

window.BasicErrorMesid = "Terjadi kesalahan, silakan coba lagi";
window.BasicErrorMesen = "An error occurred please try again";

window.ErrorInSavingAccountid = "Terjadi kesalahan dalam Menyimpan Akun, Silakan Coba Lagi Nanti";
window.ErrorInSavingAccounten = "An Error occured when Saving the Account Please Try Again Later";

window.ErrorWhenUpdatingUserInfoid = "Terjadi kesalahan saat memperbarui Informasi Pengguna, silakan coba lagi";
window.ErrorWhenUpdatingUserInfoen = "An error occurred when updating User Info, please try again";

window.ErrorInConnectServerid = "Terjadi kesalahan saat menghubungkan server, silakan coba lagi.";
window.ErrorInConnectServeren = "An Error occured when Connecting the Server please try again.";

window.ErrorWhenSendEmailTxtid = "Terjadi kesalahan saat mengirim email, silakan coba lagi.";
window.ErrorWhenSendEmailTxten = "An Error occurred when sending the email, please try again.";

window.YourAccTempDisabledContactUsErrorid = "Mohon maaf, akun Anda <a class='InterMediumItalicTextFont'>dinonaktifkan sementara</a> karena aktivitas yang tidak wajar. Silakan hubungi tim Layanan Pelanggan <a class='InterMediumItalicTextFont'>kami <a class='InterMediumItalicTextFont HyperlinkUnderlineText' href='mailto:cs@pingingo.com' target='_blank'>cs@pingingo.com</a> untuk mendapatkan bantuan dalam menyelesaikan masalah ini. Kami siap membantu!";
window.YourAccTempDisabledContactUsErroren =  "We're sorry, but your account has been <a class='InterMediumItalicTextFont'>temporarily disabled</a> due to unusual activity. Please reach out to our <a class='InterMediumItalicTextFont'>Customer Service <a class='InterMediumItalicTextFont HyperlinkUnderlineText' href='mailto:cs@pingingo.com' target='_blank'>cs@pingingo.com</a> team</a> for assistance in resolving this matter. We're here to help!";

window.ErrorWhenPrepareShareInfoid = "Gagal menyiapkan data berbagi. Coba lagi.";
window.ErrorWhenPrepareShareInfoen = "Failed to prepare share data. Try again.";

window.YouNeedToLogiTxtid = "Anda perlu Login untuk melakukan tindakan ini!";
window.YouNeedToLogiTxten = "You need to Login to perform this action!";

window.EmailAlreadyRegisteredTxtid = "Email ini sudah mendaftar!";
window.EmailAlreadyRegisteredTxten = "The inputted email already register their account!";

window.EmailOrPassInvalidErrTxtid = "Email atau Kata Sandi salah, coba dengan email atau kata sandi lain."
window.EmailOrPassInvalidErrTxten = "Email or Password is invalid, try with another email or password.";

window.ErrorWhenRequestRewardsTxtid = "Gagal Tukar Poin, Silakan Coba Lagi.";
window.ErrorWhenRequestRewardsTxten = "Failed to Request Reward, Please Try Again.";

window.ErrorLinkExpiredTxtid = "Link Kedaluwarsa";
window.ErrorLinkExpiredTxten = "Link Expired";

window.ErrorAlreadyResetPasswordTxtid = "Tautan pengaturan ulang kata sandi Anda tidak valid atau sudah digunakan. Silakan minta tautan baru.";
window.ErrorAlreadyResetPasswordTxten = "Your password reset link is either invalid or has already been used. Please request a new link";

window.EmailMustBeValidEmailAddressTxtid = "Kolom email harus berisi alamat email yang valid.";
window.EmailMustBeValidEmailAddressTxten = "The email field must be a valid email address.";

window.FailedToResetPasswordTxtid = "Gagal mengatur ulang kata sandi, silakan coba lagi";
window.FailedToResetPasswordTxten = "Failed to reset password, please try again";

window.FailedToResetPasswordTxtid = "Gagal mengatur ulang kata sandi, silakan coba lagi";
window.FailedToResetPasswordTxten = "Failed to reset password, please try again";

window.AdaMasalahKoneksiErrorTxtid = "Ada masalah dengan koneksi. Coba Lagi";
window.AdaMasalahKoneksiErrorTxten = "There was a problem with the connection. Try Again";

window.URLFormatInvalidTxtid = "Format URL Tidak Valid!";
window.URLFormatInvalidTxten = "URL Format Invalid!";

window.ErrorWhenLogOutTxtid = "Terjadi kesalahan saat mencoba keluar dari akun Anda. Silakan coba lagi!";
window.ErrorWhenLogOutTxten = "There's an Error when trying to sign out of your account. Please try again!";

window.LanguageInvalidTxtid = "Bahasa yang dipilih tidak valid.";
window.LanguageInvalidTxten = "The selected language is invalid.";

window.PleaseSelectARoomOrItemFirstTxtid = "Silakan pilih Item atau Ruangan sebelum Anda melanjutkan";
window.PleaseSelectARoomOrItemFirstTxten = "Please select an Item or Room before you continue";

// SIGN IN OR CREATE ACC RELATED ================================================================================================

window.SignInOrCreateAccHeaderTxtid = "Masuk atau Buat Akun";
window.SignInOrCreateAccHeaderTxten = "Sign In or Create Account";

window.TermAndConditionMessageid = "Dengan masuk atau membuat akun, Anda menyetujui <br><a target=\"_blank\" rel=\"noopener noreferrer\" href=\"/termsandcondition\" class=\"InterBoldItalicTextFont HyperlinkUnderlineText\">Syarat & Ketentuan</a> dan <a target=\"_blank\" rel=\"noopener noreferrer\" href=\"/privacy\" class=\"InterBoldItalicTextFont HyperlinkUnderlineText\">Pernyataan Privasi</a> kami.";
window.TermAndConditionMessageen = "By signing in or creating an account, you agree with our<br><a target=\"_blank\" rel=\"noopener noreferrer\" href=\"/termsandcondition\" class=\"InterBoldItalicTextFont HyperlinkUnderlineText\">Terms & conditions</a> and <a target=\"_blank\" rel=\"noopener noreferrer\" href=\"/privacy\" class=\"InterBoldItalicTextFont HyperlinkUnderlineText\">Privacy statement</a>";

window.AlmostDoneHeaderTextid = "Selangkah Lagi!"; // Almost There ------
window.AlmostDoneHeaderTexten = "Almost There";

window.ThankYouForVerThenCompleteProfid = "Terima kasih telah memverifikasi akun dan membuat kata sandi. Langkah selanjutnya, lengkapi profilmu di bawah ini atau bisa diisi nanti di halaman profil.";
window.ThankYouForVerThenCompleteProfen = "Thank you for verifying your account and setting up a password. The next step is to complete your profile below. You can also fill it in later on my profile page.";

window.YourAccountHasVerifiedid = "Akunmu sudah terverifikasi!"; // Your Account Success Verif ------
window.YourAccountHasVerifieden = "Your Account has been verified";

window.ThankYouForVerifiedMesid = "Terima kasih sudah memverifikasi akunmu. Sekarang, buat password untuk melanjutkan pendaftaran.";
window.ThankYouForVerifiedMesen = "Thank you for verifying your account, your account has been verified. Next, create your password to continue the registration";

window.AccCreateSuccessWeltoPingid = "Akunmu sudah aktif!";
window.AccCreateSuccessWeltoPingen = "Welcome to PinginGo";

window.AccCreateSuccessMessageid = "Saatnya menjelajah pengalaman seru dan keindahan alam bersama PinginGo";
window.AccCreateSuccessMessageen = "Your account has been successfully created and ready to explore PinginGo";

window.OrUserOtherOpTxtid = "masuk lebih cepat dengan"; // Use Following Opt ------
window.OrUserOtherOpTxten = "or use one of these options";

window.LinkWillExpTxtid = "Tautan ini akan kedaluwarsa dalam <span class='InterBoldTextFont' id='DurationTextEmailConfirmation'>14 menit: 52 detik</span> demi keamanan akun Anda."; // Link Expire Mesage ------
window.LinkWillExpTxten = "This link will expired within <span class='InterBoldTextFont' id='DurationTextEmailConfirmation'>14 min : 52 Sec</span> to avoid security issues.";

window.LinkWillExpiredTxtFunc = function(thistextdisplayer)
{
    let DurationTimeText = document.createElement("span");
    DurationTimeText.className = "InterBoldTextFont";
    DurationTimeText.innerHTML = "14 menit: 52 detik";

    thistextdisplayer.innerHTML = "";

    if(window.CurrentCountryID == "en")
    {
        thistextdisplayer.append(
            "This link will expire within ",
            DurationTimeText,
            " to avoid security issues."
        );
    }
    else
    {
        thistextdisplayer.append(
            "Tautan ini akan kedaluwarsa dalam ",
            DurationTimeText,
            " demi keamanan akun Anda."
        );
    }

    return DurationTimeText;
}
window.CreatePasswordTxtid = "Buat Kata Sandi"; // Create Pass Header ------
window.CreatePasswordTxten = "Create Password";

// ROOM HOTEL SECTION ==============================================================

window.OrderNumberTxtid = "Nomor Pesanan";
window.OrderNumberTxten = "Order Number";

window.ChangeGuestRoomAmountTxtid = "Ubah Tamu dan Kamar";
window.ChangeGuestRoomAmountTxten = "Change Guest and Room";

window.ChangeRoomTxtid = "Ubah Kamar";
window.ChangeRoomTxten = "Change Room";

window.ChangeRoomAmountTxtid = "Ubah Jumlah Kamar";
window.ChangeRoomAmountTxten = "Change Room Amount";

window.RoomAmountTxtid = "Jumlah Kamar";
window.RoomAmountTxten = "Room Amount";

window.ChangeItemAmountTxtid = "Ubah Jumlah Item";
window.ChangeItemAmountTxten = "Change Item Amount";

window.ItemAmountTxtid = "Jumlah Item";
window.ItemAmountTxten = "Item Amount";

window.ChangeExperienceTxtid = "Ubah Experience";
window.ChangeExperienceTxten = "Change Experience";

window.RoomTypeTxtid = "Tipe Kamar";
window.RoomTypeTxten = "Room Type";

window.RoomOrItemTypeTxtid = "Tipe Kamar / Item";
window.RoomOrItemTypeTxten = "Room / Item Type";

window.RoomOrExperienceTypeTxtid = "Tipe Kamar / Experience";
window.RoomOrExperienceTypeTxten = "Room / Experience Type";

window.ChooseRoomOrExperienceTypeTxtid = "Pilih Tipe Kamar / Experience";
window.ChooseRoomOrExperienceTypeTxten = "Choose Room / Experience Type";

window.TamuDewasaTxtid = "Tamu Dewasa";
window.TamuDewasaTxten = "Adult Guest";

window.TamuAnakTxtid = "Tamu Anak";
window.TamuAnakTxten = "Child Guest";


window.MaximumRoomTxtFunc = function(value, isabreviated)
{
    let ErrorToReturn = "";

    if(isabreviated == false)
    {
        if(value <= 1)
        {
            ErrorToReturn = "Maximum of " + value + " Room Available.";

            if(window.CurrentCountryID == "id")
            {
                ErrorToReturn = "Hanya tersedia maksimal " + value + " kamar.";
            }
        }
        else
        {
            ErrorToReturn = "Maximum of " + value + " Rooms Available.";

            if(window.CurrentCountryID == "id")
            {
                ErrorToReturn = "Hanya tersedia maksimal " + value + " Kamar.";
            }
        }
    }
    else
    {
        ErrorToReturn = "Only " + value + " Available.";

        if(window.CurrentCountryID == "id")
        {
            ErrorToReturn = "Hanya  " + value + " tersedia.";
        }
    }

    return  ErrorToReturn;
};

window.QuotaTidakBoleh0Txtid = "Kuota tidak boleh 0";
window.QuotaTidakBoleh0Txten = "The quota cannot be zero";

window.KebijakanReservasiTxtid = "Kebijakan Reservasi";
window.KebijakanReservasiTxten = "Reservation Policy";

window.MaximuDatemRangeTxtFunc = function(value, isabreviated)
{
    let ErrorToReturn = "";

    if(isabreviated == false)
    {
        if(value <= 1)
        {
            ErrorToReturn = "Please select a check-in date at least " + value + " day in advance";

            if(window.CurrentCountryID == "id")
            {
                ErrorToReturn = "Silakan pilih tanggal check-in minimal " + value + " hari sebelumnya";
            }
        }
        else
        {
            ErrorToReturn = "Please select a check-in date at least " + value + " days in advance";

            if(window.CurrentCountryID == "id")
            {
                ErrorToReturn = "Silakan pilih tanggal check-in minimal " + value + " hari sebelumnya";
            }
        }
    }
    else
    {
        ErrorToReturn = "Minimum advance booking: " + value + " days.";

        if(window.CurrentCountryID == "id")
        {
            ErrorToReturn = "Minimal pemesanan " + value + " hari sebelumnya.";
        }
    }

    return  ErrorToReturn;
};

window.MinRangeTextLeft = function(value)
{
    let MessageToReturn = "Rencanakan perjalananmu lebih awal. Penginapan ini menerima reservasi <span class='InterExBoldItalicTextFont'>minimal " + value + " hari</span> sebelum check-in.";

    if(window.CurrentCountryID == "en")
    {
        MessageToReturn = "Plan your trip in advance. This accommodation accepts reservations <span class='InterExBoldItalicTextFont'>at least " + value + " day</span> prior to check-in.";

        if(value > 1)
        {
            MessageToReturn = "Plan your trip in advance. This accommodation accepts reservations <span class='InterExBoldItalicTextFont'>at least " + value + " days</span> prior to check-in.";
        }
    }

    return MessageToReturn
};

window.MinRangeTextRight = function(value)
{
    let MessageToReturn = "Akomodasi ini menerima pemesanan yang di pesan <span class='InterExBoldItalicTextFont'>minimal " + value + " hari</span> sebelum tanggal menginap.";

    if(window.CurrentCountryID == "en")
    {
        MessageToReturn = "This accommodation accepts bookings made <span class='InterExBoldItalicTextFont'>at least " + value + " day</span> prior to the stay date.";

        if(value > 1)
        {
            MessageToReturn = "This accommodation accepts bookings made <span class='InterExBoldItalicTextFont'>at least " + value + " days</span> prior to the stay date.";
        }
    }

    return MessageToReturn
};


window.RoomsUnavailableTxtid = "Kamar Tidak Tersedia";
window.RoomsUnavailableTxten = "Room Unavailable";

window.ExperiencesUnavailableTxtid = "Experience Tidak Tersedia";
window.ExperiencesUnavailableTxten = "Experience Unavailable";

window.RoomUnavailableWithCurrentSetTxtid = "Maaf, kami tidak menemukan kamar yang sesuai dengan tanggal atau jumlah kamar yang dipilih.";
window.RoomUnavailableWithCurrentSetTxten = "Room unavailable with the current Date or Room Quota setting";

window.NoFeaturedPropertyTxtid = "Tidak ada rekomendasi properti yang ditemukan";
window.NoFeaturedPropertyTxten = "No Featured Property Found";

window.NoFeaturedPropertyTxtid = "Tidak ada rekomendasi properti yang ditemukan";
window.NoFeaturedPropertyTxten = "No Featured Property Found";

window.FeaturedComesToThisProvTxtid = "Properti unggulan akan segera tersedia di provinsi ini";
window.FeaturedComesToThisProvTxten = "Featured properties will be available soon in this province";

window.NoAccommodationAvailableTxtid = "Tidak Ada Penginapan Tersedia";
window.NoAccommodationAvailableTxten = "No Accommodation Available";

window.PleaseChangeFilterTxtid = "Coba ubah filter, tanggal, atau lokasi untuk menemukan pilihan lainnya.";
window.PleaseChangeFilterTxten = "Please change your Filter, Date or Location to find a new one";

window.NoRoomAvailableHeaderTxtid = "Tidak Ada Kamar Tersedia";
window.NoRoomAvailableHeaderTxten = "No Room Available";

window.NoRoomAvailableMessageTxtid = "Silakan ubah filter, tanggal, atau klik <span class='InterBoldTextFont'>'Jelajahi Lebih Lanjut'</span> untuk menemukan akomodasi baru";
window.NoRoomAvailableMessageTxten = "Please change your filter, date, or click <span class='InterBoldTextFont'>'Explore more'</span> to find a new one";

window.NoExperienceAvailableHeaderTxtid = "Tidak Ada Experience Tersedia";
window.NoExperienceAvailableHeaderTxten = "No Experience Available";

window.NoExperienceAvailableMessageTxtid = "Silakan ubah filter, tanggal, atau klik <span class='InterBoldTextFont'>'Jelajahi Lebih Lanjut'</span> untuk menemukan Experience baru";
window.NoExperienceAvailableMessageTxten = "Please change your filter, date, or click <span class='InterBoldTextFont'>'Explore more'</span> to find a new one";

window.TrendingAccOnTxtid = "🌿Penginapan Populer di";
window.TrendingAccOnTxten = "🌿Trending Accommodations on";

window.TrendingExpOnTxtid = "🌿Experience Populer di";
window.TrendingExpOnTxten = "🌿Trending Experience on";

// EMAIL CONFIRMATION ================================================================================================

window.EmailConfirmationTxtid = "Verifikasi Email Anda";
window.EmailConfirmationTxten = "Email Confirmation";

window.WeHaveSentEmailValidTxtid = "Kami telah mengirim email ke <span class='InterBoldTextFont' id='EmailTextInConfirmation'>---</span> untuk memverifikasi alamat email Anda.<br>Silakan buka email tersebut dan klik tautan yang kami kirim untuk melanjutkan pendaftaran. Jangan lupa cek folder spam.";
window.WeHaveSentEmailValidTxten = "We have sent email to <span class='InterBoldTextFont' id='EmailTextInConfirmation'>---</span> to confirm the validity of email address.<br>After receiving the email please follow the link provided to continue the registration. Don't forgot to check spam folder.";

window.WeHaveSentEmailValidTxt = function(whichcountryid, whatemail)
{
    // Email To Display -------------------------
    let EmailToSend = "<span class='InterBoldTextFont' id='EmailTextInConfirmation'>---</span>";
    if(whatemail != null)
        EmailToSend = "<span class='InterBoldTextFont'>" + whatemail + "</span>";

    // Message To Send -------------------------
    let MessageReturn = "Kami telah mengirim email ke " + EmailToSend +" untuk memverifikasi alamat email Anda.<br>Silakan buka email tersebut dan klik tautan yang kami kirim untuk melanjutkan pendaftaran. Jangan lupa cek folder spam.";

    if(whichcountryid == "en")
        MessageReturn = "We have sent email to " + EmailToSend + " to confirm the validity of email address.<br>After receiving the email please follow the link provided to continue the registration. Don't forgot to check spam folder.";

    return MessageReturn;
}


window.IfYouGotNoEmailTxtid = "Tidak menerima email?";
window.IfYouGotNoEmailTxten = "If you not got an email";

// FORGOT PASSWORD ==============================================================================

window.ForgotPasswordSendEmailButtonTxtid = "Kirim Link Pemulihan";
window.ForgotPasswordSendEmailButtonTxten = "Forgot Password";

window.ResetPasswordMessageTxtid = "Masukkan alamat email Anda, kami akan mengirimkan tautan pemulihan ke email tersebut.";
window.ResetPasswordMessageTxten = "Enter your email address and we will send you the recovery link.";

window.RecoveryLinkHasSentTxtid = "Tautan pemulihan telah dikirim";
window.RecoveryLinkHasSentTxten = "Recovery link has been sent";

window.WeHaveSendRecoveryEmailToTxtid = function(value) { return "Kami telah mengirimkan tautan pemulihan ke <span class='InterBoldTextFont'>" + value + "</span>. Setelah menerima email, silakan ikuti tautan yang diberikan untuk mengubah kata sandi Anda. Jangan lupa periksa folder spam Anda.";};
window.WeHaveSendRecoveryEmailToTxten = function(value) { return "We have sent the recovery link to <span class='InterBoldTextFont'>" + value + "</span> After receiving the email please follow the link provided to change your password. Don't forget to check your spam folder.";};

window.ResetPasswordHeaderTxtid = "Atur Ulang Kata Sandi";
window.ResetPasswordHeaderTxten = "Reset Password";

window.SavePasswordButtonTxtid = "Simpan Kata Sandi";
window.SavePasswordButtonTxten = "Save Password";

window.ErrorPasswordNeverBeenSetTxtid = "Terjadi kesalahan, kata sandi belum pernah diatur.";
window.ErrorPasswordNeverBeenSetTxten = "Error, password has never been set";

window.ResetPasswordSuccessTxtid = "Reset Kata Sandi Berhasil";
window.ResetPasswordSuccessTxten = "Reset Password Success";

window.FailedRequestResetPasswordTxtid = "Permintaan pengaturan ulang kata sandi gagal.";
window.FailedRequestResetPasswordTxten = "Failed to request reset password";

window.PasswordBerhasilTersimpanTxtid = "Password berhasil tersimpan";
window.PasswordBerhasilTersimpanTxten = "Password successfully saved";

window.PasswordGagalTersimpanTxtid = "Password gagal tersimpan";
window.PasswordGagalTersimpanTxten = "Password failed to save";

window.TidakAdaDataMemberCocokTxtid = "Tidak ada data member dan user yang cocok";
window.TidakAdaDataMemberCocokTxten = "There is no matching member and user data";

window.UserNotFoundTxtid = "User tidak ditemukan";
window.UserNotFoundTxten = "User not found";

window.PasswordNotBeenSetTxtid = "Kata sandi sudah diatur";
window.PasswordNotBeenSetTxten = "Password has already been set";

window.VerificationExpiredTxtid = "Verifikasi telah kedaluwarsa. Silakan minta email verifikasi baru.";
window.VerificationExpiredTxten = "Verification has expired. Please request a new verification email.";


window.StatusSavePasswordTxt = function(value)
{
    if(value == "Password berhasil tersimpan")
    {
        return window["PasswordBerhasilTersimpanTxt" + window.CurrentCountryID];
    }
    else if(value == "Tidak ada data member dan user yang cocok")
    {
        return window["TidakAdaDataMemberCocokTxt" + window.CurrentCountryID];
    }
    else if(value == "Email has not been verified")
    {
        return window["EmailUnverifiedTxt" + window.CurrentCountryID];
    }
    else if(value == "Member not found")
    {
        return window["UserNotFoundTxt" + window.CurrentCountryID];
    }
    else if(value == "Password has already been set")
    {
        return window["PasswordNotBeenSetTxt" + window.CurrentCountryID];
    }
    else if(value == "Verification has expired. Please request a new verification email.")
    {
        return window["VerificationExpiredTxt" + window.CurrentCountryID];
    }
    else if(value == "The email field is required.")
    {
        return window["EmailCannotEmpty" + window.CurrentCountryID];
    }
    else if(value == "The new password field must be at least 8 characters.")
    {
        return window["MinPassWarningTxt2" + window.CurrentCountryID];
    }
    else
    {
        return window["PasswordGagalTersimpanTxt" + window.CurrentCountryID];
    }
}

// Index ================================================================================================

window.PleaseInputYourDestinationTxtid = "Silakan masukkan tujuan Anda";
window.PleaseInputYourDestinationTxten = "Please insert your Destination";

window.PopularDestinationHeaderid = "⭐️Destinasi Menginap Populer di Indonesia";
window.PopularDestinationHeaderen = "⭐️Popular Area to Stay in Indonesia";

window.PopularDestinationMesid = "Temukan destinasi terbaik di area hits Indonesia, siap untuk staycation atau liburan panjang.";
window.PopularDestinationMesen = "Discover the best destinations in Indonesia's hottest areas, ready for a staycation or long vacation.";

window.RecommendedHotelHeaderid = "👍Rekomendasi Penginapan untuk Anda";
window.RecommendedHotelHeaderen = "👍Featured Accommodation for You";

window.TrendingAccForYouTxtid = "🌿Penginapan Populer di Indonesia";
window.TrendingAccForYouTxten = "🌿Trending Accommodation in Indonesia";

window.AccUnder300KTxtid = "💸Penginapan di Bawah 300 Ribu";
window.AccUnder300KTxten = "Accommodations Under 300k";

window.OrangeLoginNowIndexTextid = "Login Sekarang, Kumpulin Poin & Liburan Hemat Berkali-kali!";
window.OrangeLoginNowIndexTexten = "Login Now, Collect Points & Save on Vacations Many Times Over!"


window.HelpCenterTxtid = "Pusat Bantuan";
window.HelpCenterTxten = "Help Center";


window.DaftarkanAkomodasiBottomPartMessageid = "Daftarkan Penginapan Anda di";
window.DaftarkanAkomodasiBottomPartMessageen = "Register your accommodation at";
window.ShowCaseYourAccBottomPartMessageid = "Perlihatkan Keindahan Alam Penginapan Anda: Jadilah Hidden Gem, Glamping, Villa, atau Resort dengan Pengalaman Menginap Tak Terlupakan";
window.ShowCaseYourAccBottomPartMessageen = "Showcase the Natural Beauty of Your Accommodation: Be a Hidden Gem, Glamping, Villa, or Resort with an Unforgettable Stay Experience"; 
window.GabungSekarangBottomPartid = "Gabung Sekarang";
window.GabungSekarangBottomParten = "Join Now";

window.OrangeIndexMobileHeadTxtid = "Login, Dapatkan Lebih!";
window.OrangeIndexMobileHeadTxten = "Login Now and Get More!";
window.OrangeIndexMobileMesTxtid = "Booking lebih cepat, kumpulkan poin dari setiap pesanan & sharing, bonusnya bisa dipakai buat liburan berikutnya.";
window.OrangeIndexMobileMesTxten = "Book faster, collect points from every booking & sharing, the bonus can be used for your next vacation.";




// Update Profile ================================================================================================

window.WarningUpdateUserDataSuccessid = "Profil Pengguna berhasil diperbarui!";
window.WarningUpdateUserDataSuccessen = "User Profile successfully updated!";

window.UserNotFoundTxtid = "Akun pengguna tidak ditemukan";
window.UserNotFoundTxten = "User account not found";

window.WarningUpdateUserDataFailedid = "Gagal menyimpan data, silakan coba lagi nanti";
window.WarningUpdateUserDataFaileden = "Failed to save data, please try again later";

window.ChangePhotoSuccessMessageid = "Foto Profil Anda telah berhasil diperbarui!";
window.ChangePhotoSuccessMessageen = "Your Profile Photo has been successfully updated!";

window.ChangePhotoErrorMessageid = "Terjadi kesalahan saat mengunggah gambar, silakan coba lagi nanti";
window.ChangePhotoErrorMessageen = "An error occurred when uploading the image, please try again later";

window.UpdateReferralAndUserInfoSuccessTxtid = "Kode referral dan info pengguna berhasil diperbarui!";
window.UpdateReferralAndUserInfoSuccessTxten = "Referral and user info updated successfully!";

// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! MY PROFILE !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

window.WarningReferralMyProfileInvalidid = "ID Referral Tidak Valid";
window.WarningReferralMyProfileInvaliden = "Invalid Referral ID";

window.WarningReferralMyProfileSuccessTxtid = "Referral berhasil di tambahkan";
window.WarningReferralMyProfileSuccessTxten = "Success: Referral can be used!!";

window.WarningReferralCanBeUsedTxtid = "Kode referral dapat digunakan";
window.WarningReferralCanBeUsedTxten = "Referral code can be used";

window.WarningReferralFailedTxtid = "Kode referral gagal digunakan";
window.WarningReferralFailedTxten = "Failed to apply referral code";

// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! SEARCH RESULT !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

window.PopularFilterInHeaderTxtid = "Filter Populer di";
window.PopularFilterInHeaderTxten = "Popular Filter in";

window.SorryNoAccFoundTxtid = "Maaf, tidak ada akomodasi yang ditemukan";
window.SorryNoAccFoundTxten = "Sorry, No accommodation found";

window.AdjustDateOrFiltersTxtid = "Ubah tanggal atau sesuaikan filter agar mendapat hasil yang cocok";
window.AdjustDateOrFiltersTxten = "Adjust the date or modify the filters to find a match";

window.GoToAccommodationTxtid = "Cek Penginapan";
window.GoToAccommodationTxten = "Go to Accommodation";

window.SortByTxtid = "Urutkan";
window.SortByTxten = "Sort by";

// Sort Button -----------------------------------------

// --- Best Match ---
window.BestMatchTxtid = "Paling Sesuai";
window.BestMatchTxten = "Best Match";
window.BestMatchAbvTxtid = "Sesuai";
window.BestMatchAbvTxten = "Best";

// --- Lowest Price ---
window.LowestPriceTxtid = "Harga Termurah";
window.LowestPriceTxten = "Lowest Price";
window.LowestPriceAbvTxtid = "Hrg Min";
window.LowestPriceAbvTxten = "Min Price";
// Alternative text: id: "Hrg Min", en: "Min Price"

// --- Hot Deals ---
window.HotDealsTxtid = "Promo Spesial";
window.HotDealsTxten = "Hot Deals";
window.HotDealsAbvTxtid = "Promo";
window.HotDealsAbvTxten = "Deals";

// --- Almost Full ---
window.AlmostFullTxtid = "Hampir Habis";
window.AlmostFullTxten = "Almost Full";
window.AlmostFullAbvTxtid = "Sisa Dikit";
window.AlmostFullAbvTxten = "Ltd Qty";

// ------------------------------------------------------

window.BudgetPerNightTxtid = "Harga per Malam";
window.BudgetPerNightTxten = "Budget per Night";

window.MinHeaderTxtid = "Mulai Dari";
window.MinHeaderTxten = "Min";

window.MaxHeaderTxtid = "Maks";
window.MaxHeaderTxten = "Max";

window.CategoryHeaderTxtid = "Kategori";
window.CategoryHeaderTxten = "Category";

window.EditPhotoButtonTxtid = "Ubah Foto";
window.EditPhotoButtonTxten = "Edit Photo";
// window["" + window.CurrentCountryID]

// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! HOTEL DETAILS !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

window.WhatPeopleSayAboutTxtid = function(value){ return "Apa kata mereka tentang " + value};
window.WhatPeopleSayAboutTxten = function(value){ return "What people say about " + value};

window.SeeAllPhotosTxtid = "Lihat Semua Foto";
window.SeeAllPhotosTxten = "See All Photos";

window.WeAreSorryTxtid = "Maaf, Kamar ini sedang penuh";
window.WeAreSorryTxten = "We are Sorry";

window.RoomUnavailableFullyBookedTxtid = "Silakan ubah filter, tanggal, atau lokasi untuk menemukan pilihan lainnya";
window.RoomUnavailableFullyBookedTxten = "Rooms Unavailable: Fully Booked or Limited Availability";

window.StartFromTxtid = "Mulai Dari";
window.StartFromTxten = "Start From";

window.YouSavedTxtid = "Kamu hemat";
window.YouSavedTxten = "You Saved";

window.YouSavedTxt2id = "Kamu berhasil hemat";
window.YouSavedTxt2en = "You managed to save";

window.BayardiTempatTxtid = "Bayar di tempat";
window.BayardiTempatTxten = "Pay on the spot";

window.ViewMoreExpTxtid = "Lihat Lebih Banyak Pengalaman";
window.ViewMoreExpTxten = "View More Experiences";

window.DownPaymentPriceTxtid = "Pembayaran Uang Muka";
window.DownPaymentPriceTxten = "Down Payment Price";

window.AddOnsTxtid = "Add-Ons";
window.AddOnsTxten = "Add-Ons";

window.EstimatedFinalPriceTxtid = "Total Harga";
window.EstimatedFinalPriceTxten = "Estimated Final Price";

window.SeeNearbyOnMapTxtid = "Lihat Lokasi Sekitar di Peta";
window.SeeNearbyOnMapTxten = "See Nearby On Map";

window.YouHaveFinishedStayingExprezyTxtid = function(value){ return "Kamu baru saja selesai menginap di <span class='InterBoldTextFont'>" + value + "</span>🌿. Yuk, ceritain pengalaman seru kamu di sini!";};
window.YouHaveFinishedStayingExprezyTxten = function(value){ return "You have finished staying at <span class='InterBoldTextFont'>" + value + "</span>, you can share your memorable experiences activities at " + value + " Riverside here";};

window.TellMeYourExperiencesTxtid = "Ceritain pengalamanmu & kasih rating untuk penginapan ini ⭐";
window.TellMeYourExperiencesTxten = "Tell me your experience and give rating about the property";

window.PlaceholderTellMeExperiencesTxtid = "Tulis pengalaman seru kamu di sini... ✍️";
window.PlaceholderTellMeExperiencesTxten = "Tell me how good is your experiences";

window.RatingMustBetween1To5Txtid = "Rating Pengalaman harus antara 1 dan 5.";
window.RatingMustBetween1To5Txten = "The rating must be between 1 and 5.";

window.UserExperienceCannotBeEmptyTxtid = "Pengalaman Tidak Boleh Kosong!";
window.UserExperienceCannotBeEmptyTxten = "Experiences cannot be Empty!";

window.FailedToSendUserExTxtid = "Gagal mengunggah Pengalaman Pengguna!"
window.FailedToSendUserExTxten = "Failed to upload User Experience!";

window.ExperiencePhotoCannotEmptyTxtid = "Foto tidak boleh kosong!"
window.ExperiencePhotoCannotEmptyTxten = "Photo cannot be empty!";

window.ErrorBookingNotFoundForThisUserTxtid = "Booking tidak ditemukan untuk pengguna ini"
window.ErrorBookingNotFoundForThisUserTxten = "Booking not found for this user";

window.ErrorExprezyAlreayExistTxtid = "Pengalaman untuk pemesanan ini sudah ada";
window.ErrorExprezyAlreayExistTxten = "Experience already exists for this booking";

window.IDExperinceInvalidTxtid = "ID Pengalaman tidak valid"
window.IDExperinceInvalidTxten = "Experience ID is invalid";

window.FailedToUploadExprezyPhotoTxtid = "Gagal mengunggah foto Ping Exprezy."
window.FailedToUploadExprezyPhotoTxten = "Failed to upload Ping Exprezy Photo.";

window.HotelNotActiveTxtid = "Error: Akomodasi tidak aktif"
window.HotelNotActiveTxten = "Error: Accommodation is Inactive";

window.ErrorImageMustBeImageFileTxtid = "Gambar harus berupa file gambar."
window.ErrorImageMustBeImageFileTxten = "The image must be an image file.";

// window["" + window.CurrentCountryID]

// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! PAYMENT PAGE !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

window.Step1PaymentTxtid = "Detail Pemesanan";
window.Step1PaymentTxten = "Booking Details";

window.Step2PaymentTxtid = "Opsi Pembayaran";
window.Step2PaymentTxten = "Payment Option";

window.Step3PaymentTxtid = "Pemesanan Berhasil";
window.Step3PaymentTxten = "Booking Confirmed";

window.ChangeButtonPaymentTxtid = "Ubah";
window.ChangeButtonPaymentTxten = "Change";

window.UpdateBookingDetailsTxtid = "Ubah Detail Pemesanan";
window.UpdateBookingDetailsTxten = "Update Booking Details";

window.OrangeMessagePaymentDetailsTopTxtid = "<span class=\"InterBoldTextFont HyperlinkUnderlineText\" onclick=\"InstantiateLoginPanel('')\">Masuk</span> untuk melengkapi detail pemesanan dengan lebih mudah atau Daftar dengan mengisi formulir di bawah ini";
window.OrangeMessagePaymentDetailsTopTxten = "<span class=\"InterBoldTextFont HyperlinkUnderlineText\" onclick=\"InstantiateLoginPanel('')\">Sign In</span> to easier complete the booking details or Register with fill up the form below";

window.PaymentDetailsTxtid = "Detail Pembayaran";
window.PaymentDetailsTxten = "Payment Details";

window.WaitingPaymentTxtid = "Menunggu Pembayaran";
window.WaitingPaymentTxten = "Waiting Payment";

window.BlubyBCADigitalTxtid = "blu by BCA Digital";
window.BlubyBCADigitalTxten = "blu by BCA Digital";

window.AddCardCreditTxtid = "Tambahkan Kartu / Kartu Kredit";
window.AddCardCreditTxten = "Add Card / Credit Card";

window.BookingConfirmedTxtid = "Pemesanan Berhasil";
window.BookingConfirmedTxten = "Booking Confirmed";

window.PingHotelSuccessfulTxtid = "Pemesanan Berhasil";
window.PingHotelSuccessfulTxten = "Ping Hotel Successful";

// window.BookingSuccessMessageTxtid = function(value) { return "Seru banget, pesananmu sudah aman.<br> Ajak temanmu menginap lewat kode referral biar kamu dapat poin ekstra buat liburan berikutnya ✨"};
// window.BookingSuccessMessageTxten = function(value) { return "<span class='InterBoldTextFont'>" + value + " Traveller</span> has already Ping this hotel. Invite others to get max discount, and periodically check to find out the discounts obtained.<br><span class='InterBoldTextFont'>More Ping, more discount!</span>";};

window.BookingSuccessMessageTxtid = "Seru banget, pesananmu sudah aman.<br> Ajak temanmu menginap lewat kode referral biar kamu dapat poin ekstra buat liburan berikutnya ✨";
window.BookingSuccessMessageTxten = "It's so much fun, your order is safe.<br> Invite your friends to stay with us using your referral code so you can get extra points for your next vacation ✨";

window.PaymentTimeoutTxtid = "Waktu Pembayaran Habis";
window.PaymentTimeoutTxten = "Payment Timeout";

window.PaymentTimeoutMessageTxtid = "Pembayaran gagal diproses karena waktu habis. Silakan pilih metode pembayaran lain atau coba lagi.";
window.PaymentTimeoutMessageTxten = "Your payment could not be processed due to a timeout issue. Select another payment method or retry payment.";

window.BookingCancelledHeaderTxtid = "Error: Pemesanan Dibatalkan";
window.BookingCancelledHeaderTxten = "Error: Booking Cancelled";

window.BookingCancelledMessageTxtid = "Terjadi kesalahan. Silakan kembali ke bagian detail pemesanan dan coba lagi pemesanan akomodasi.";
window.BookingCancelledMessageTxten = "An error occurred. Please return to the booking details section, and retry booking the accommodation.";

window.RetryPaymentBtnTxtid = "Ulangi Pembayaran";
window.RetryPaymentBtnTxten = "Retry Payment";

window.ChangeBankBtnTxtid = "Ganti Metode";
window.ChangeBankBtnTxten = "Change Bank";

window.BookingFailedTxtid = "Pembayaran Gagal";
window.BookingFailedTxten = "Booking Failed";

window.AnotherPaymentBtnTxtid = "Pembayaran Lain";
window.AnotherPaymentBtnTxten = "Another Payment";

window.NeedHelpBtnTxtid = "Butuh bantuan?";
window.NeedHelpBtnTxten = "Need Help?";

window.BookingFailedMessageTxtid = "Pembayaran tidak berhasil karena terjadi kendala. Silakan coba lagi nanti atau pilih metode pembayaran lainnya.";
window.BookingFailedMessageTxten = "The payment was unsuccessful due to an abnormality. Please try again later or choose another payment.";

window.TotalBookingToBePaidTxtid = "Total yang harus dibayar";
window.TotalBookingToBePaidTxten = "Total to be paid";

window.BookingForSomeoneTxtid = "Pesankan untuk orang lain?";
window.BookingForSomeoneTxten = "Booking for someone else?";

window.RoomsPreferenceTxtid = "Preferensi Kamar";
window.RoomsPreferenceTxten = "Rooms Preference";

window.NonSmokingRoomTxtid = "Kamar Bebas Rokok";
window.NonSmokingRoomTxten = "Non-Smoking Room";

window.SmokingRoomTxtid = "Boleh Merokok";
window.SmokingRoomTxten = "Smoking Room";

window.BreakfastIncludeTxtid = "Sarapan termasuk jika pilih kamar ini";
window.BreakfastIncludeTxten = "Breakfast include if you ping this room";

window.InputReferralCodeMesTxtid = "Masukkan kode referral dari teman Anda";
window.InputReferralCodeMesTxten = "Input referral code from your friends below";

window.InputReferralCodePlaceholderTxtid = "Masukkan Kode referral disini";
window.InputReferralCodePlaceholderTxten = "Input Referral Code here";

window.YourReferralIsInvalidTxtid = "Kode Referral Anda tidak valid."
window.YourReferralIsInvalidTxten = "Your Referral Code is invalid.";

window.YourReferralAlreadyUsedTxtid = "Kode Referral sudah digunakan.";
window.YourReferralAlreadyUsedTxten = "Referral Code already used.";

window.YourReferralAlreadyUsedorInvalidTxtid = "Kode Referral Anda Tidak Valid atau Sudah Digunakan.";
window.YourReferralAlreadyUsedorInvalidTxten = "Your Referral Code is Invalid or Already Used.";

window.ApplyReferralBtnTxtid = "Terapkan Referral";
window.ApplyReferralBtnTxten = "Apply Referral";

window.ReferralAppliedTxtid = "Referral Ditambahkan";
window.ReferralAppliedTxten = "Referral Applied";

window.DoYouHaveVoucherTxtid = "Apakah Anda Memiliki Voucher?";
window.DoYouHaveVoucherTxten = "Do You Have Voucher?";

window.ApplyVoucherMessageTxtid = "Masukkan kode voucher untuk menambahkan potongan harga";
window.ApplyVoucherMessageTxten = "Apply voucher code to get discount";

window.InputVoucherCodePlaceholderTxtid = "Masukkan Kode Voucher disini";
window.InputVoucherCodePlaceholderTxten = "Input Voucher Code here";

window.ApplyVoucherBtnTxtid = "Terapkan Voucher";
window.ApplyVoucherBtnTxten = "Apply Voucher";

window.VoucherAppliedTxtid = "Voucher Ditambahkan";
window.VoucherAppliedTxten = "Voucher Applied";

window.VoucherNotEligibleTxtid = "Voucher tidak berlaku";
window.VoucherNotEligibleTxten = "Voucher not eligible";

window.YourVoucherIsInvalidTxtid = "Kode Voucher Anda Tidak Valid";
window.YourVoucherIsInvalidTxten = "Your Voucher Code is Invalid";

window.YourVoucherIsInvalidOrUsedTxtid = "Kode Voucher Anda Tidak Valid atau Sudah Digunakan.";
window.YourVoucherIsInvalidOrUsedTxten = "Your Voucher Code is Invalid or Already Used.";

window.QuotaVoucherAlreadyFinishTxtid = "Kuota untuk voucher ini sudah habis";
window.QuotaVoucherAlreadyFinishTxten = "No more quota available for this voucher";

window.YourPingPoinTxtid = "Ping Poin Anda";
window.YourPingPoinTxten = "Your Ping Point";

window.UsePingPoinToPayTxtid = "Gunakan Ping Poin";
window.UsePingPoinToPayTxten = "Use Ping Poin to Pay";

window.OriginalPriceTxtid = "Harga Awal";
window.OriginalPriceTxten = "Original Price";

window.HideButtonTxtid = "Lebih Sedikit";
window.HideButtonTxten = "Hide";

window.HideButtonTxt2id = "Sembunyikan";
window.HideButtonTxt2en = "Hide";


window.YouSavedTxt2id = "Potongan Harga";
window.YouSavedTxt2en = "You Saved";

window.ByProceedingMessageTxtid = "Dengan melanjutkan pemesanan ini, saya menyetujui <a class=\"InterBoldTextFont HyperlinkUnderlineText\" href=\"/termsandcondition\">Syarat Penggunaan</a> dan <a class=\"InterBoldTextFont HyperlinkUnderlineText\" href=\"/privacy\">Kebijakan Privasi PinginGo</a>.";
window.ByProceedingMessageTxten = "By proceeding with this booking, I agree to <a class=\"InterBoldTextFont HyperlinkUnderlineText\" href=\"/termsandcondition\">Pingingo Terms of Use</a> and <a class=\"InterBoldTextFont HyperlinkUnderlineText\" href=\"/privacy\">Privacy Policy</a>.";

window.AboutPaymentPaymentSecHeaderTxtid = "Tentang Pembayaran";
window.AboutPaymentPaymentSecHeaderTxten = "About Payment";

window.DownPaymentAgreeMessageTxtid = "<span class='InterBoldTextFont'>Uang muka akan dikenakan saat Anda menyetujui pemesanan properti ini</span>. Sisa pembayaran akan dilakukan oleh tamu saat check-in.";
window.DownPaymentAgreeMessageTxten = "<span class='InterBoldTextFont'>Down Payment payment charged when you agree to booking this property</span>. The estimated payment can become even cheaper when someone makes a booking at the hotel. The final payment will be made by the customer upon check-in.";

window.TotalPaymentTxtid = "Total Pembayaran";
window.TotalPaymentTxten = "Total Payment";

window.DownPaymentTxtid = "Uang Muka";
window.DownPaymentTxten = "Down Payment";

window.PayDownPaymentTxtid = "Pembayaran Uang Muka";
window.PayDownPaymentTxten = "Pay Down Payment";

window.PaymentMethodTxtid = "Metode Pembayaran";
window.PaymentMethodTxten = "Payment Method";

window.PayatHotelTxtid = "Bayar di Penginapan";
window.PayatHotelTxten = "Pay at Accommodation";

window.NextChoosePaymentButtonTxtid = "Lanjut: Pilih Pembayaran";
window.NextChoosePaymentButtonTxten = "Next: Choose Payment";

window.AnAdditionalWillBePaidTxtid = "Sisa pembayaran <span class='InterBoldTextFont PayAtHotelPriceText' rp-type='1' final-zero='true'>Rp ------</span> akan dibayar di <span class='InterBoldTextFont' id='HotelNameAnAdditional'>Radisson Blu Bali Uluwatu</span>";
window.AnAdditionalWillBePaidTxten = "An additional <span class='InterBoldTextFont PayAtHotelPriceText' rp-type='1' final-zero='true'>Rp ------</span> will be charged <span class='InterBoldTextFont' id='HotelNameAnAdditional'>---------</span>";

window.InstantPaymentTxtid = "Instant Payment";
window.InstantPaymentTxten = "Bayar Instan";

window.DigitalPaymentTxtid = "Dompet Digital";
window.DigitalPaymentTxten = "Digital Payment";

window.CreditCardHeaderTxtid = "Kartu Kredit";
window.CreditCardHeaderTxten = "Credit Card";

window.DirectTransferTxtid = "Transfer Langsung";
window.DirectTransferTxten = "Direct Transfer";

window.VirtualAccountTxtid = "Virtual Account";
window.VirtualAccountTxten = "Virtual Account";

window.ConfirmNPayButtonTxtid = "Lanjut: Pilih Pembayaran";
window.ConfirmNPayButtonTxten = "Confirm & Pay";

window.PleaseCompletePayTxtid = "Selesaikan pembayaran dalam <span class='InterBoldTextFont CountDownPaymentText'>6 menit 52 detik</span> untuk menghindari pembatalan. Lanjutkan pembayaran menggunakan detail rekening bank di bawah ini.";
window.PleaseCompletePayTxten = "Please complete payment within <span class='InterBoldTextFont CountDownPaymentText'>30min : 52 Sec</span> to avoid cancelation. Please proceed ahead with the payment using the Bank Account details as mentioned below.";

window.AccountNumberTxtid = "Nomor Rekening";
window.AccountNumberTxten = "Account Number";

window.bluAccountHeaderTxtid = "Akun blu";
window.bluAccountHeaderTxten = "blu Account";

window.bluAccountNotFoundErrorTxtid = "Akun blu tidak ditemukan. Coba Lagi";
window.bluAccountNotFoundErrorTxten = "Blu account not found. Try again";

window.bluAccountNotFoundErrorTxt2id = "Akun tidak ditemukan, gunakan no Hp yang terdaftar di blu.";
window.bluAccountNotFoundErrorTxt2en = "Account not found, use the mobile number registered on blu.";

window.FailedToRequestBluPaymentTxtid = "Gagal Meminta Pembayaran blu";
window.FailedToRequestBluPaymentTxten = "Failed to Request blu Payment";

window.NoHandphoneTerdaftarBluTxtid = "No Handphone yang terdaftar di blu";
window.NoHandphoneTerdaftarBluTxten = "Phone Number that registered on blu";

window.RequestBluPaymentBtnTxtid = "Request Pembayaran blu";
window.RequestBluPaymentBtnTxten = "Request blu Payment";

window.VirtualAccountNumberHeaderTxtid = "Nomor Virtual Akun";
window.VirtualAccountNumberHeaderTxten = "Virtual Account Number";

window.AlreadyPayHyperlinkTxtid = "Sudah Bayar? <span class='InterBoldTextFont HyperlinkUnderlineText' id='RefreshHyperlinkButton'>Refresh</span>";
window.AlreadyPayHyperlinkTxten = "Aready Pay? <span class='InterBoldTextFont HyperlinkUnderlineText' id='RefreshHyperlinkButton'>Refresh</span>";

window.AlreadyPayHyperlink2Txtid = "Sudah Bayar? <span class='InterBoldTextFont HyperlinkUnderlineText' id='RefreshHyperlinkButton'>Check Booking</span>";
window.AlreadyPayHyperlink2Txten = "Aready Pay? <span class='InterBoldTextFont HyperlinkUnderlineText' id='RefreshHyperlinkButton'>Check Booking</span>";

window.RefreshPaymentHyperlinkTxtid = "Refresh";
window.RefreshPaymentHyperlinkTxten = "Refresh";

window.TampilkanQRISTxtid = "Tampilkan QRIS";
window.TampilkanQRISTxten = "Show QRIS";

window.VerifyPaymentDirectHyperlinkTxtid = "Verifikasi Pembayaran";
window.VerifyPaymentDirectHyperlinkTxten = "Verify Payment";

window.VoucherVoucherAppliedTxtid = "Voucher <span class='OrangeButton VoucherAppliedText'>Voucher Terpakai</span>";
window.VoucherVoucherAppliedTxten = "Voucher <span class='OrangeButton VoucherAppliedText'>Voucher Applied</span>";

window.ErrorWhenRequestBookingTxtid = "Terdapat masalah saat merequest booking. Coba Lagi";
window.ErrorWhenRequestBookingTxten = "There was a problem requesting a booking. Please try again";

window.SeeBookingDetailsTxtid = "Lihat Detail Pemesanan";
window.SeeBookingDetailsTxten = "See Booking Details";


window.PreviousOnGoingPaymentFoundTxtid ="Pembayaran Aktif Ditemukan";
window.PreviousOnGoingPaymentFoundTxten = "Previous Ongoing Payment Found";

window.PreviousOnGoingPaymentFoundMessageTxtid = "Sebelumnya Anda memesan kamar dengan status yang sama tanpa memilih metode pembayaran apa pun. Anda dapat memeriksa detail pemesanan melalui Menu <a class='InterBoldTextFont'>Perjalan Saya</a>, atau melanjutkan pembayaran dengan mengeklik tombol <a class='InterBoldTextFont'>Lanjutkan Pembayaran</a>.";
window.PreviousOnGoingPaymentFoundMessageTxten = "Previously you booked a room(s) with the same status without any payment method selected. You can check the booking details from <a class='InterBoldTextFont'>My Ping</a> Menu, or continue the payment by clicking the <a class='InterBoldTextFont'>Continue Payment</a> button.";



window.FailedToPushBookingMessageTxtid = "Pembayaran tidak berhasil karena terjadi kendala. Silakan coba lagi nanti atau pilih metode pembayaran lainnya."
window.FailedToPushBookingMessageTxten = "Payment was unsuccessful due to a problem. Please try again later or choose another payment method.";

window.ChangePaymentMethodTxtid = "Ganti Metode Pembayaran";
window.ChangePaymentMethodTxten = "Change Payment Method";

window.ContinuePaymentBtnTxtid = "Lanjutkan Pembayaran";
window.ContinuePaymentBtnTxten = "Continue Payment";

window.GoToMyPingBtnTxtid = "Buka Perjalanan Saya";
window.GoToMyPingBtnTxten = "Go to My Ping";

window.PreviousBookingExpiredHeaderTxtid ="Sesi Booking Telah Berakhir";
window.PreviousBookingExpiredHeaderTxten = "Booking Session Expired";

window.PreviousBookingExpiredMessageTxtid = "Sesi pemesanan Anda telah berakhir karena batas waktu atau tidak ada aktivitas. Silakan muat ulang halaman untuk melanjutkan proses pemesanan, atau buka <a class='InterBoldTextFont'>Detail Pemesanan</a> untuk melihat reservasi Anda.";
window.PreviousBookingExpiredMessageTxten = "Your booking session has expired due to inactivity or time limit. Please refresh the page to continue the booking process, or go to <a class='InterBoldTextFont'>Booking Details</a> to review your reservation.";

window.RefreshPageBtnTxtid = "Muat Ulang Halaman";
window.RefreshPageBtnTxten = "Refresh Page";

window.VerifyYourPaymentBtnTxtid = "Verifikasi Pembayaran Anda";
window.VerifyYourPaymentBtnTxten = "Verify your Payment";

window.TransferDateTxtid = "Tanggal Transfer";
window.TransferDateTxten = "Transfer Date";

window.TransferDatePlaceHolderTxtid = "Masukkan Tanggal Transfer";
window.TransferDatePlaceHolderTxten = "Input Transfer Date";

window.TransferTimeTxtid = "Waktu Transfer";
window.TransferTimeTxten = "Transfer Time";

window.TransferTimePlaceHolderTxtid = "Masukkan Waktu Transfer";
window.TransferTimePlaceHolderTxten = "Input Transfer Time";


window.BankAccountTxtid = "Nama Rekening Bank";
window.BankAccountTxten = "Bank Account";

window.BankAccountPlaceHolderTxtid = "Masukkan Nama Rekening Bank";
window.BankAccountPlaceHolderTxten = "Insert Bank Account User Name";

window.BankAccountWarningEmptyTxtid = "Nama Rekening Bank Tidak Bisa Kosong";
window.BankAccountWarningEmptyTxten = "Bank Account cannot be Empty";


window.AccountNumberTxtid = "Nomor Rekening";
window.AccountNumberTxten = "Account Number";

window.AccountNumberPlaceHolderTxtid = "Masukkan Nomor Rekening";
window.AccountNumberPlaceHolderTxten = "Insert Account Number";

window.AccountNumberWarningEmptyTxtid = "Nomor Rekening Tidak Bisa Kosong";
window.AccountNumberWarningEmptyTxten = "Account Number cannot be Empty";

window.NamaAkunTxtid = "Nama Akun";
window.NamaAkunTxten = "Account Name";

// Add On ------------------------------------------------------------------------------

window.AddOnHeaderTxtid = "Detail Tambahan";
window.AddOnHeaderTxten = "Additional Details";

window.TotalTambahanTxtid = "Total Tambahan";
window.TotalTambahanTxten = "Additional Total";

// Bank Choice --------------------------------------------------------------------------

window.QRISTxtid = "QRIS";
window.QRISTxten = "QRIS";

window.BLUTxtid = "blu oleh BCA Digital";
window.BLUTxten = "blu by BCA Digital";

window.BankINATxtid = "Bank INA (Virtual Account Bank Lainnya)";
window.BankINATxten = "INA Bank (Virtual Account of Other Banks)";

window.BankINADescriptionTxtid = "Kamu bisa menggunakan VA dari bank yang belum tersedia dengan Bank INA";
window.BankINADescriptionTxten = "You can use VA from banks that are not yet available with Bank INA";


// Credit Card --------------------------------------------------------------------------

window.WeProtectYourPrivacyTxtid = "Kami menjaga informasi kartu Anda tetap aman dan terenkripsi. Kode keamanan kartu Anda (CVV/CVC) tidak akan disimpan. Anda dapat menghapus kartu kapan saja.";
window.WeProtectYourPrivacyTxten = "We keep your card information secure and encrypted. Your card security code (CVV/CVC) will not be stored. You can delete your card at any time.";

window.WeProtectYourPrivacy2Txtid = "<span class='InterBoldTextFont'>Pembayaran Aman</span><br>Anda akan diarahkan ke halaman pembayaran aman <span class='InterBoldItalicTextFont'>(secure page)</span> untuk mengisi detail kartu. PinginGo tidak menyimpan informasi kartu Anda.";
window.WeProtectYourPrivacy2Txten = "<span class='InterBoldTextFont'>Secure Payment</span><br>You will be redirected to a secure payment page <span class='InterBoldItalicTextFont'>(secure page)</span> to fill in your card details. PinginGo does not store your card information.";

window.CardNumberTxtid = "Nomor Kartu";
window.CardNumberTxten = "Card Number";

window.ExampleCrefitCardInputTxtid = "Contoh: 1234 5678 1234 5678";
window.ExampleCrefitCardInputTxten = "Example: 1234 5678 1234 5678";

window.ExpiryDateTxtid = "Tanggal Kedaluwarsa";
window.ExpiryDateTxten = "Expiration Date";

window.SafetyCodeHeaderTxtid = "Kode Keaamanan";
window.SafetyCodeHeaderTxten = "Safety Code";

window.CardHolderNameTxtid = "Nama Pemilik Kartu";
window.CardHolderNameTxten = "Cardholder Name";

window.CardHolderInputFieldTxtid = "Masukkan nama pemilik kartu";
window.CardHolderInputFieldTxten = "Enter the cardholder name";

window.JumlahTransferTxtid = "Jumlah Transfer";
window.JumlahTransferTxten = "Amount";

window.JumlahTransferPlaceHolderTxtid = "Masukkan Jumlah Transfer disini";
window.JumlahTransferPlaceHolderTxten = "Input Amount Paid here";

window.JumlahTransferWarningEmptyTxtid = "Jumlah Transfer Tidak Bisa Kosong";
window.JumlahTransferWarningEmptyTxten = "Amount Paid cannot be Empty";

window.VerificationPaymentInProgressTxtid = "Verifikasi Pembayaran Sedang Diproses";
window.VerificationPaymentInProgressTxten = "Verification Payment in Progress";

window.OurTeamIsCheckingPaymentMesTxtid = "Tim kami sedang memeriksa pembayaran Anda. Kami akan memberi tahu Anda segera setelah pembayaran berhasil.";
window.OurTeamIsCheckingPaymentMesTxten = "Our team is checking your payment, we will notify you if your payment is successful.";


window.CompleteYourProfileHeaderTxtid = "Complete Your Profile";
window.CompleteYourProfileHeaderTxten = "Lengkapi Profil Kamu";

window.CompleteYourProfileMessageTxtid = "<span class='InterBoldTextFont HyperlinkUnderlineText' onclick=\"InstantiateLoginPanel('')\">Lengkapi profil kamu</span> untuk memudahkan proses pemesanan";
window.CompleteYourProfileMessageTxten = "<span class='InterBoldTextFont HyperlinkUnderlineText' onclick=\"InstantiateLoginPanel('')\">Complete your profile</span> to easier complete the booking details";

window.StepRuleDirect =
{
    "en":
    [
        "When you have successfully completed your payment, please Verify Payment.",
        "The direct transfers take longer to check, please be patient for our team to verify the payment.",
        "When you have successfully completed your payment, we will confirm your booking within few minutes through mail and SMS."
    ],
    "id":
    [
        "Setelah berhasil melakukan pembayaran, silakan klik Verifikasi Pembayaran.",
        "Transfer langsung membutuhkan waktu pengecekan lebih lama, mohon bersabar hingga tim kami memverifikasi.",
        "Setelah pembayaran berhasil diverifikasi, kami akan mengonfirmasi pemesanan Anda melalui email dalam beberapa menit."
    ]
}

window.StepRuleBlu =
{
    "en":
    [
        "The payment notification via Blu will appear on your smartphone.",
        "Next, you will be directed to the transaction confirmation page in the Blu application.",
        "If you do not receive the payment notification on your Blu app. Open your Blu app, then click on the Notifications menu.",
        "When you have successfully completed your payment, we will confirm your booking within few minutes through mail and SMS."
    ],
    "id":
    [
        "Notifikasi pembayaran melalui Blu akan muncul di smartphone kamu.",
        "Selanjutnya, kamu akan diarahkan ke halaman konfirmasi transaksi di aplikasi Blu.",
        "Jika kamu tidak menerima notifikasi pembayaran di aplikasi Blu, buka aplikasi Blu dan klik menu Notifikasi.",
        "Setelah pembayaran berhasil, kami akan mengonfirmasi pemesananmu melalui email dalam beberapa menit."
    ]
}

window.StepRuleVA =
{
    "en":
    [
        "When you have successfully completed your payment, we will confirm your booking within few minutes through mail and SMS."
    ],
    "id":
    [
        "Begitu pembayaranmu berhasil, kami akan mengonfirmasi pemesanan lewat email dalam beberapa menit."
    ]
}

window.StepPayVABasedOnTypeTxt =
{
    "Mandiri":
    [
        {
            "header":
            {
                "id":"Cara bayar via Livin’ by Mandiri",
                "en":"How to pay via Livin’ by Mandiri"
            },
            "message":
            {
                "id":
                [
                    "Buka aplikasi Livin’ by Mandiri dan login",
                    "Pilih menu Bayar / Virtual Account lalu klik Buat Pembayaran Baru",
                    "Masukkan nomor Virtual Account (tap untuk salin)",
                    "Periksa detail & pilih rekening, lalu klik Lanjut Bayar",
                    "Masukkan PIN Livin’ untuk menyelesaikan transaksi"
                ],
                "en":
                [
                    "Open the Livin' by Mandiri app and log in",
                    "Select the Payment / Virtual Account menu, then click Create New Payment",
                    "Enter the Virtual Account number (tap to copy)",
                    "Check the details and select the account, then click Continue Payment",
                    "Enter your Livin' PIN to complete the transaction"
                ]
            }
        }
    ],
    "BCA":
    [
        {
            "header":
            {
                "id":"Cara bayar via BCA Mobile / My BCA",
                "en":"How to pay via BCA Mobile / My BCA"
            },
            "message":
            {
                "id":
                [
                    "Buka aplikasi BCA mobile / myBCA atau gunakan ATM BCA",
                    "Pilih menu m-Transfer lalu BCA Virtual Account",
                    "Masukkan nomor Virtual Account (tap untuk salin)",
                    "Periksa nama dan nominal pembayaran",
                    "Konfirmasi dan masukkan PIN untuk menyelesaikan transaksi"
                ],
                "en":
                [
                    "Open the BCA mobile / myBCA app or use a BCA ATM",
                    "Select the m-Transfer menu then BCA Virtual Account",
                    "Enter the Virtual Account number (tap to copy)",
                    "Check the name and payment amount",
                    "Confirm and enter your PIN to complete the transaction."
                ]
            }
        }
    ],
    "Danamon":
    [
        {
            "header":
            {
                "id":"Cara bayar via D-Bank Pro",
                "en":"How to pay via D-Bank Pro"
            },
            "message":
            {
                "id":
                [
                    "Buka aplikasi D-Bank PRO atau Internet Banking Danamon",
                    "Pilih menu Transfer → Ke Rekening Lain / Bank Lain",
                    "Masukkan nomor Virtual Account (tap untuk salin)",
                    "Periksa nama dan nominal pembayaran",
                    "Konfirmasi dan masukkan PIN untuk menyelesaikan transaksi"
                ],
                "en":
                [
                    "Open the D-Bank PRO app or Danamon Internet Banking",
                    "Select the Transfer menu → To Another Account / Another Bank",
                    "Enter the Virtual Account number (tap to copy)",
                    "Check the name and payment amount",
                    "Confirm and enter your PIN to complete the transaction."
                ]
            }
        }
    ],
    "BRI":
    [
        {
            "header":
            {
                "id":"Cara bayar via BRImo",
                "en":"How to pay via BRImo"
            },
            "message":
            {
                "id":
                [
                    "Buka aplikasi BNI Mobile Banking",
                    "Pilih menu Transfer → Virtual Account Billing.",
                    "Masukkan nomor Virtual Account (tap untuk salin)",
                    "Periksa nama dan nominal pembayaran",
                    "Konfirmasi dan masukkan PIN untuk menyelesaikan transaksi"
                ],
                "en":
                [
                    "Open the BNI Mobile Banking application",
                    "Select the Transfer menu → Virtual Account Billing",
                    "Enter the Virtual Account number (tap to copy)",
                    "Check the name and payment amount",
                    "Confirm and enter your PIN to complete the transaction."
                ]
            }
        }
    ],
    "BNI":
    [
        {
            "header":
            {
                "id":"Cara bayar via BNI Mobile Banking",
                "en":"How to pay via BNI Mobile Banking"
            },
            "message":
            {
                "id":
                [
                    "Buka aplikasi BNI Mobile Banking",
                    "Pilih menu Transfer → Virtual Account Billing",
                    "Masukkan nomor Virtual Account (tap untuk salin)",
                    "Periksa nama dan nominal pembayaran",
                    "Konfirmasi dan masukkan PIN untuk menyelesaikan transaksi"
                ],
                "en":
                [
                    "Open the BNI Mobile Banking application",
                    "Select the Transfer → Virtual Account Billing menu",
                    "Enter the Virtual Account number (tap to copy)",
                    "Check the name and payment amount",
                    "Confirm and enter your PIN to complete the transaction."
                ]
            }
        }
    ],
    "Permata":
    [
        {
            "header":
            {
                "id":"Cara bayar via PermataMobile X",
                "en":"How to pay via PermataMobile X"
            },
            "message":
            {
                "id":
                [
                    "Buka aplikasi PermataMobile X dan login.",
                    "Pilih menu \"Pay\" atau \"Pembayaran\". Pilih \"Virtual Account\".",
                    "Masukkan nomor Virtual Account (tap untuk salin)",
                    "Periksa nama dan nominal pembayaran",
                    "Konfirmasi dan masukkan PIN untuk menyelesaikan transaksi"
                ],
                "en":
                [
                    "Open the PermataMobile X app and log in.",
                    "Select the \"Pay\" or \"Payment\" menu. Select \"Virtual Account\".",
                    "Enter the Virtual Account number (tap to copy).",
                    "Check the name and payment amount.",
                    "Confirm and enter your PIN to complete the transaction."
                ]
            }
        }
    ],
    "BSI":
    [
        {
            "header":
            {
                "id":"Cara bayar via BYOND by BSI",
                "en":"How to pay via BYOND by BSI"
            },
            "message":
            {
                "id":
                [
                    "Buka aplikasi BYOND by BSI dan login.",
                    "Pilih menu Bayar & Beli. Pilih Virtual Account",
                    "Masukkan nomor Virtual Account (tap untuk salin)",
                    "Periksa nama dan nominal pembayaran",
                    "Konfirmasi dan masukkan PIN untuk menyelesaikan transaksi"
                ],
                "en":
                [
                    "Open the BYOND by BSI app and log in.",
                    "Select the Pay & Buy menu. Select Virtual Account.",
                    "Enter the Virtual Account number (tap to copy).",
                    "Check the name and payment amount.",
                    "Confirm and enter your PIN to complete the transaction."
                ]
            }
        }
    ],
    "CIMB":
    [
        {
            "header":
            {
                "id":"Cara bayar via OCTO Mobile",
                "en":"How to pay via OCTO Mobile"
            },
            "message":
            {
                "id":
                [
                    "Login ke aplikasi OCTO Mobile",
                    "Pilih menu Pembelian & Isi Ulang -> eWallet",
                    "Pilih jenis eWallet (jika terkait).",
                    "Masukkan Nomor Ponsel / Virtual Account",
                    "Konfirmasi dan masukkan PIN untuk menyelesaikan transaksi"
                ],
                "en":
                [
                    "Log in to the OCTO Mobile app",
                    "Select the Purchase & Top-Up -> eWallet menu",
                    "Select the eWallet type (if applicable)",
                    "Enter your mobile number / virtual account",
                    "Confirm and enter your PIN to complete the transaction"
                ]
            }
        }
    ],
    "BINA":
    [
        {
            "header":
            {
                "id":"Cara bayar via Binadigital app",
                "en":"How to pay via Binadigital app"
            },
            "message":
            {
                "id":
                [
                    "Login ke aplikasi Binadigital app",
                    "Pilih menu \"Bayar Tagihan\" atau \"Transfer\"",
                    "Pilih opsi \"Virtual Account\"",
                    "Masukkan Nomor Ponsel / Virtual Account",
                    "Konfirmasi dan masukkan PIN untuk menyelesaikan transaksi"
                ],
                "en":
                [
                    "Log in to the Binadigital app",
                    "Select the \"Bayar Tagihan\" (Pay Bills) or \"Transfer\"",
                    "Select \"Virtual Account\"",
                    "Enter your mobile number / virtual account",
                    "Confirm and enter your PIN to complete the transaction"
                ]
            }
        },
        {
            "header":
            {
                "id":"Cara bayar via Transfer Bank Lain/ATM Bersama",
                "en":"How to pay via Other Banks Transfer"
            },
            "message":
            {
                "id":
                [
                    "Pilih menu \"Transfer ke Bank Lain di ATM\" atau \"Mobile Banking Anda\".",
                    "Masukkan kode Bank INA Perdana \"(513)\"",
                    "Masukkan nomor rekening tujuan dengan nomor Virtual Account yang tertera.",
                    "Konfirmasi nominal pembayaran dan selesaikan transaksi."
                ],
                "en":
                [
                    "Select \"Transfer\" or \"Transfer Antar Bank\" (Interbank Transfer) in your banking app or ATM.",
                    "Select Bank INA Perdana as the destination bank or use code 513.",
                    "Enter the 16-digit Virtual Account Number as the destination account.",
                    "Enter the total amount to be paid.",
                    "Confirm the transfer."
                ]
            }
        }
    ],
}





window.CaraBayarviaQRISTxtid = "Cara bayar via QRIS";
window.CaraBayarviaQRISTxten = "How to pay via QRIS";

window.StepRuleQRIS =
{
    "en":
    [
        "Click Show QR Code",
        "Open the e-wallet / mobile banking application that supports QRIS",
        "Select the Scan QR / Pay menu",
        "Check the nominal amount then confirm payment"
    ],
    "id":
    [
        "Klik Tampilkan Kode QR",
        "Buka aplikasi e-wallet / mobile banking yang mendukung QRIS",
        "Pilih menu Scan QR / Bayar",
        "Periksa nominal lalu konfirmasi pembayaran"
    ]
}

window.GuestTxtid = "Tamu";
window.GuestTxten = "Guest";

window.GuestTxtexid = "Tamu";
window.GuestTxtexen = "Guests";

window.CopyVaButtonTxtid = "Salin Nomor VA";
window.CopyVaButtonTxten = "Copy VA";

window.PilihdanBayarTxtid = "Pilih dan Bayar";
window.PilihdanBayarTxten = "Select and Pay";

window.ErrorWhenVerifyDirectTxtid = "Terjadi kesalahan ketika mengirimkan verifikasi Transfer Langsung. Mohon coba kembali.";
window.ErrorWhenVerifyDirectTxten = "An error occurred while sending the Direct Transfer verification. Please try again.";

window.ErrorPushUserDataTxtid = "Terjadi kesalahan saat mengirim data pengguna baru, silakan coba lagi.";
window.ErrorPushUserDataTxten = "An Error occurred when push new user data, please try again";

window.ErrorEmailAlreadyVerifiedPaymentTxtid = "Email sudah terverifikasi sebagai Anggota. Silakan masuk untuk melanjutkan.";
window.ErrorEmailAlreadyVerifiedPaymentTxten = "Email already verified as Member. Please login to continue."

window.ErrorAccountAlreadyInactiveTxtid = "Akun Anda tidak aktif. Silakan hubungi layanan pelanggan untuk mengaktifkan kembali akun Anda.";
window.ErrorAccountAlreadyInactiveTxten = "Your account is non-active. Please contact customer service to reactivate your account."

window.CheckPaymentStatusFailedErrorTxtid = "Pemeriksaan status Pembayaran Gagal";
window.CheckPaymentStatusFailedErrorTxten = "Failed Payment Status Check";

// QRIS --------------------------------------------------------------------------

window.YellowTopQRISShowTxtid = "Scan dan Harap melakukan pembayaran dalam <span class='InterBoldTextFont'>10 Menit</span> untuk menghindari pembatalan.";
window.YellowTopQRISShowTxten = "Scan and Please make payment within <span class='InterBoldTextFont'>10 Minutes</span> to avoid cancellation.";

window.LoadingQRISButtonTxtid = "Membuat QRIS";
window.LoadingQRISButtonTxten = "Creating QRIS";

window.SaveQRISButtonTxtid = "Simpan QRIS";
window.SaveQRISButtonTxten = "Save QRIS";

window.RequestQRISFailedTxtid = "Permintaan QRIS gagal";
window.RequestQRISFailedTxten = "QRIS request failed";

window.QRISCheckFailedErrorTxtid = "Pemeriksaan status QRIS gagal.";
window.QRISCheckFailedErrorTxten = "QRIS check status failed";

// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! MY PING !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

window.PingOnGoingTxtid = "Perjalanan Berlangsung";
window.PingOnGoingTxten = "Ping Ongoing";

window.NoPingOngoingHeadTxtid = "Belum Ada Pemesanan Berlangsung";
window.NoPingOngoingHeadTxten = "No Ping Ongoing";

window.NoPingOngoingMesTxtid = "Mulai jelajahi penginapan & coba Pesan sekarang";
window.NoPingOngoingMesTxten = "No Accommodation Ping yet, explore Accommodation and make a Ping";

window.PastPingTxtid = "Riwayat Perjalanan";
window.PastPingTxten = "Past Ping";

window.NoPaymentMethodSelectedTxtid = "Metode pembayaran belum dipilih";
window.NoPaymentMethodSelectedTxten = "No Payment Method Selected";

window.SelectandPayTxtid = "Pilih dan Bayar";
window.SelectandPayTxten = "Select and Pay";

window.RemainingAmountTxtid = "Sisa Pembayaran";
window.RemainingAmountTxten = "Remaining Amount";

// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! MY PROFILE !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

window.PunyaKodeRefHeaderTxtid = "Punya kode referral?";
window.PunyaKodeRefHeaderTxten = "Have a referral code?";

window.InputReferralCodePlaceholderTxt2id = "Masukkan ID referral Temanmu di sini";
window.InputReferralCodePlaceholderTxt2en = "Input yout friends Referral Code";

window.GetDiscountMessageRefBottomTxtid = "Dapatkan voucher diskon + referral poin setelah referral ter-verifikasi";
window.GetDiscountMessageRefBottomTxten = "Get discount voucher + referral points after referral is verified";

window.AddReferralBtnTxtid = "Tambahkan Referral";
window.AddReferralBtnTxten = "Add Referral";

window.ReferralVerifiedTxtid = "Referral Terverifikasi";
window.ReferralVerifiedTxten = "Referral Verified";

window.ConfirmationReferralHeaderTxtid = "Apakah kamu yakin ingin menggunakan Kode Referral ini?";
window.ConfirmationReferralHeaderTxten = "Are you sure you want to use this Referral Code?";

window.DoYouProceedUseThisReferralTxtid = "Periksa kembali apakah Kode Referral yang kamu masukkan sudah sesuai.";
window.DoYouProceedUseThisReferralTxten = "Please double check whether the Referral Code you entered is correct.";

window.UseReferralCodeBtnTxtid = "Gunakan Kode Referral";
window.UseReferralCodeBtnTxten = "Use Referral Code";

window.MyReferralCodeTxtid = "Kode Referral Mu";
window.MyReferralCodeTxten = "My Referral Code";

// window["Test" + window.CurrentCountryID];

// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! BOOKING DETAILS !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

window.YouHaveBookedPreviouslyMesTxtid = function(value){ return "Liburanmu di " + value + " sudah selesai 🌿. Yuk, bagikan momen seru & pengalamanmu di sini!";};
window.YouHaveBookedPreviouslyMesTxten = function(value){ return "You have finished staying at " + value +", you can share your memorable experiences activities at " + value + " here";};

window.ShareExperienceBtnTxtid = "Bagikan Pengalaman ✨";
window.ShareExperienceBtnTxten = "Submit Experience";

window.NoBookingDetailsFoundHeaderTxtid = "Detail Pemesanan Tidak Ditemukan";
window.NoBookingDetailsFoundHeaderTxten = "Booking Details Not Found";

window.NoBookingDetailsFoundMessageTxtid = "Kami tidak dapat menemukan detail pemesanan untuk permintaan Anda. Silakan periksa ID pemesanan Anda atau coba lagi nanti.";
window.NoBookingDetailsFoundMessageTxten = "We couldn't find any booking details for your request. Please check your booking ID or try again later.";

window.WhatYourExperienceInThisHeaderTxtid = "Pengalamanmu Sebelumnya di Akomodasi Ini";
window.WhatYourExperienceInThisHeaderTxten = "Your Experience at This Accommodation";


window.ETicketHeaderTxtid = "E-Ticket";
window.ETicketHeaderTxten = "E-Ticket";

window.ShowThisQRUponMesTxtid = "Tunjukan QR ini saat tiba di lokasi";
window.ShowThisQRUponMesTxten = "Show this QR code upon arrival at the location";

window.TicketIDTxtid = "ID Tiket";
window.TicketIDTxten = "Ticket-ID";

window.TipeTiketTxtid = "Tipe Tiket";
window.TipeTiketTxten = "Ticket Type";

window.JumlahTiketTxtid = "Jumlah Tiket";
window.JumlahTiketTxten = "Number of Tickets";

window.TanggalKunjunganTxtid = "Tanggal Kunjungan";
window.TanggalKunjunganTxten = "Visit Date";

window.LocationTxtid = "Lokasi";
window.LocationTxten = "Location";

window.StatusTicketTxtid = "Status Ticket";
window.StatusTicketTxten = "Ticket Status";

window.DownloadETicketTxtid = "Unduh E-Tiket (PDF)";
window.DownloadETicketTxten = "Download E-Ticket (PDF)";

window.InformasiPentingTxtid = "Informasi Penting";
window.InformasiPentingTxten = "Important Information";

window.InformasiPentingInfo1Txtid = "Tunjukan QR Code E-Ticket ini di loket untuk proses validasi";
window.InformasiPentingInfo1Txten = "Present this e-ticket QR code at the counter for validation";

window.InformasiPentingInfo2Txtid = "Tiket hanya berlaku pada tanggal kunjungan yang tertera";
window.InformasiPentingInfo2Txten = "The ticket is valid only for the specified date of visit";

window.InformasiPentingInfo3Txtid = "Tiket tidak dapat dibatalkan, dialihkan, atau diperjualbelikan";
window.InformasiPentingInfo3Txten = "Tickets cannot be cancelled, transferred, or resold";


// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! REFERRAL PAGE !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

window.TotalPoinHeaderTxtid = "Total Poin";
window.TotalPoinHeaderTxten = "Total Points";

window.MinTransactTxtid = "Min. Transaksi";
window.MinTransactTxten = "Minimum Transaction";

window.NoMinimumTxtid = "Tidak ada";
window.NoMinimumTxten = "No Minimum";
window.NoMinimum2Txtid = "Tidak ada Minimum";
window.NoMinimum2Txten = "No Minimum";

window.PoinDibutuhkanTxtid = "Poin Dibutuhkan";
window.PoinDibutuhkanTxten = "Required Points";

window.BatasPenukaranPerUserTxtid = "Batas Penukaran per user";
window.BatasPenukaranPerUserTxten = "Exchange Limit per user";

window.TidakadaLimitTxtid = "Tidak ada Limit";
window.TidakadaLimitTxten = "No Limit";

window.ReferralPointTxtid = "Referral Poin";
window.ReferralPointTxten = "Referral Points";

window.MemberPointTxtid = "Member Poin";
window.MemberPointTxten = "Member Points";
window.MemberPointAbrTxtid = "MP";
window.MemberPointAbrTxten = "MP";

window.PingPointTxtid = "Ping Poin";
window.PingPointTxten = "Ping Points";
window.PingPointAbrTxtid = "PP";
window.PingPointAbrTxten = "PP";

window.PointsTxtid = "Poin";
window.PointsTxten = "Points";

window.DetermineWhichPoinNameWithValue = function(value, whichtype)
{ 
    if(whichtype == "Ping Point" || whichtype == "Ping Poin")
    {
        return value + " " + window["PingPointTxt" + window.CurrentCountryID];
    }
    else if(whichtype == "Member Point" || whichtype == "Member Poin")
    {
        return value + " " + window["MemberPointTxt" + window.CurrentCountryID];
    }
    else
    {
        return value + " " + window["ReferralPointTxt" + window.CurrentCountryID];
    }
};

window.PointUGotInvFriTxtid = "hasil dari ajak teman gabung PinginGo";
window.PointUGotInvFriTxten = "Points you earn from inviting friends";

window.PilihRewardsTxtid = "Pilih Rewards";
window.PilihRewardsTxten = "Select Rewards";

window.TukarPoinDgnRewardFavTxtid = "Tukar poinmu dengan reward favoritmu!";
window.TukarPoinDgnRewardFavTxten = "Exchange your points for your favorite rewards!";

window.BlmAdaRewardsTxtid = "Belum ada Rewards";
window.BlmAdaRewardsTxten = "No Rewards Yet";

window.BlmAdaRewardsMsgTxtid = "Belum ada rewards yang bisa kamu tukar sekarang 😅. Tapi santai aja, terus kumpulin Ping & Member Poin, nanti bisa ditukar hadiah kece buat liburanmu! ✨";
window.BlmAdaRewardsMsgTxten = "There are no rewards you can redeem right now 😅. But don't worry, keep collecting Ping & Member Points, and you can exchange them for cool prizes for your vacation! ✨";

window.TemenPinginGoTxtid = "Teman PinginGo";
window.TemenPinginGoTxten = "PinginGo Friends";

window.TemenYangBerhasilTxtid = "Teman yang berhasil kamu undang lewat referral mu";
window.TemenYangBerhasilTxten = "Friends you successfully invited via your referral";

window.PingBerhasilTxtid = "Ping Berhasil";
window.PingBerhasilTxten = "Ping Completed";

window.NumberPingCompletedBasedOnInvTxtid = "Jumlah Ping Selesai yang berhasil Anda undang melalui referensi Anda";
window.NumberPingCompletedBasedOnInvTxten = "Number of Ping Completed that you successfully invited through your referral";

window.LainnyaDotTxtid = "Lainnya...";
window.LainnyaDotTxten = "Other...";

window.TukarPoinTxtid = "Tukar Poin";
window.TukarPoinTxten = "Exchange Points";

window.ViewAllTxtid = "Lihat Semua";
window.ViewAllTxten = "View All";

window.MinTransaksiTxtid = "Min. Transaksi";
window.MinTransaksiTxten = "Min. Transaction";

window.BerlakuSDTxtid = "Berlaku s/d";
window.BerlakuSDTxten = "Valid Until";

window.NoExpDateTxtid =  "Tanpa Kadaluarsa";
window.NoExpDateTxten =  "No Valid Date";

window.ClaimDateTxtid = "Tanggal Klaim";
window.ClaimDateTxten = "Claim Date";

window.NoClaimDateTxtid = "Tidak Ada";
window.NoClaimDateTxten = "No Claim Date";

window.PoinDeductedTxtid = "Poin Terpakai";
window.PoinDeductedTxten = "Poin Deducted";

window.NoPoinDeductedTxtid = "Tidak Ada";
window.NoPoinDeductedTxten = "No Poin Deducted";

window.VoucherCodeTxtid = "Kode Voucher";
window.VoucherCodeTxten = "Voucher Code";

window.OopsNoVoucherTxtid = "Ups, tidak ada Voucher yang Ditemukan";
window.OopsNoVoucherTxten = "Oops, no Voucher Found";

window.VoucherThatYouTriedToLoadNotExistTxtid = "Voucher yang Anda coba muat tidak valid.";
window.VoucherThatYouTriedToLoadNotExistTxten = "The Voucher that you are attempting to load is not valid.";

window.NoVoucherMessageTxtid = function(value) { return "Anda tidak memiliki <span class='InterBoldTextFont'>" + value + "</span> di akun Anda";};
window.NoVoucherMessageTxten = function(value) { return "You don't have any <span class='InterBoldTextFont'>" + value + "</span> in your account";};

window.WaitRewardsExchangeHeaderTxtid = "Permintaan kamu lagi kita proses nih, estimasi maksimal 1x24 jam.";
window.WaitRewardsExchangeHeaderTxten = "We are processing your request, estimated maximum 1x24 hours.";

window.WaitRewardsExchangeTxtid = "Sabar bentar ya, voucher kamu nanti otomatis muncul di My Voucher. Jangan lupa cek email juga, karena kita bakal kasih notifikasi kalau vouchernya udah ready! 🎁✉️";
window.WaitRewardsExchangeTxten = "Please be patient, your voucher will automatically appear in My Voucher. Don't forget to check your email too, because we'll notify you when the voucher is ready! 🎁✉️";

window.KamuYakinInginMenukarTxtid = function(value) { return "Kamu yakin ingin menukar <span class='InterBoldTextFont'>" + value + "</span> dengan Rewards ini?";};
window.KamuYakinInginMenukarTxten = function(value) { return  "Are you sure you want to exchange <span class='InterBoldTextFont'>" + value + "</span> for this Reward?";};

window.HistoryPointTxtid = "Riwayat Poin";
window.HistoryPointTxten = "History Point";


// Top Button Section --------------------------------------------------------------------

window.AjakTemenDoubleCuanTxtid = "Ajak Teman, Cuan Jadi Dobel!";
window.AjakTemenDoubleCuanTxten = "Invite Friends, Double Your Cuan!";

// Ajak Temen Double Cuan -------------------------------------------------------------------

window.AjakTemenMainHeaderTxtid = "Gimana Cara Biar Cuan?";
window.AjakTemenMainHeaderTxten = "How to Make Cuan?";

window.AjakTemenNoBookingOrPingReferralHeaderTxtid = "Belum ada teman yang daftar nih";
window.AjakTemenNoBookingOrPingReferralHeaderTxten = "No friends have registered yet";

window.AjakTemenNoBookingOrPingReferralMessageTxtid = "Ayo ajak mereka join PinginGo biar kamu makin banyak dapet voucher! 🎉";
window.AjakTemenNoBookingOrPingReferralMessageTxten = "Come on, invite them to join PinginGo so you can get more vouchers! 🎉";

window.AjakTemenStep1HeaderTxtid = "Bagikan Link Referral 📲";
window.AjakTemenStep1HeaderTxten = "Share Referral Link 📲";

window.AjakTemenStep1MessageTxtid = "Sebarin link referral kamu ke semua temanmu!";
window.AjakTemenStep1MessageTxten = "Share your referral link with all your friends!";


window.AjakTemenStep2HeaderTxtid = "Registrasi ✅";
window.AjakTemenStep2HeaderTxten = "Registration ✅";

window.AjakTemenStep2MessageTxtid = "Pastikan temanmu daftar & verifikasi akun pakai Kode Referral kamu";
window.AjakTemenStep2MessageTxten = "Make sure your friends register & verify their accounts using your Referral Code.";


window.AjakTemenStep3HeaderTxtid = "Dapetin Voucher 🎁";
window.AjakTemenStep3HeaderTxten = "Get a Voucher 🎁";

window.AjakTemenStep3MessageTxtid = "Setelah temanmu daftar, kamu langsung dapet poin buat ditukar voucher nginep!";
window.AjakTemenStep3MessageTxten = "Once your friend registers, the guest immediately gets coins to exchange for a voucher to stay!";


// Nginep Gratis -------------------------------------------------------------------

window.NginepGratisMainHeaderTxtid = "Cara Mudah #NginepGratis";
window.NginepGratisMainHeaderTxten = "Easy Ways to #NginepGratis";


window.NginepGratisNoBookingOrPingReferralHeaderTxtid = "Belum Ada Teman Menginap";
window.NginepGratisNoBookingOrPingReferralHeaderTxten = "No Friends Have Stayed Over Yet";

window.NginepGratisNoBookingOrPingReferralMessageTxtid = "Yuk ajak temanmu buat Ping (Booking) akomadasi bareng di PinginGo. Setiap teman berhasil nginep, kamu langsung dapet voucher tambahan.";
window.NginepGratisNoBookingOrPingReferralMessageTxten = "Invite your friends to book accommodation together on PinginGo. For every successful stay, you'll receive an additional voucher.";



window.NginepGratisStep1HeaderTxtid = "Bagikan Penginapan Favoritmu";
window.NginepGratisStep1HeaderTxten = "Share Your Favorite Accommodation";

window.NginepGratisStep1MessageTxtid = "Pilih penginapan favoritmu, share link-nya ke teman, dan ajak mereka buat booking bareng di PinginGo.";
window.NginepGratisStep1MessageTxten = "Choose your favorite accommodation, share the link with friends, and invite them to book together on PinginGo.";


window.NginepGratisStep2HeaderTxtid = "Make Ping!";
window.NginepGratisStep2HeaderTxten = "Make Ping!";

window.NginepGratisStep2MessageTxtid = "Temanmu harus berhasil booking (Ping) akomodasi dari link yang kamu share.";
window.NginepGratisStep2MessageTxten = "Your friend must successfully book (Ping) accommodation from the link you share.";


window.NginepGratisStep3HeaderTxtid = "Dapetin Voucher";
window.NginepGratisStep3HeaderTxten = "Get a Voucher";

window.NginepGratisStep3MessageTxtid = "Setiap teman berhasil booking, kamu dapat poin yang bisa ditukar jadi voucher nginep di PinginGo.";
window.NginepGratisStep3MessageTxten = "Every time a friend successfully books a room, you'll earn points that can be exchanged for a voucher to stay at PinginGo.";


// ================================ REFERRAL ERROR =======================================

window.PleaseInputAccountThatRegisteredBeforeYouTxtid = "Silakan Input ID Referral Akun yang Registrasi Sebelum Akunmu!";
window.PleaseInputAccountThatRegisteredBeforeYouTxten = "Please input the referral ID of the account that registered before your account!";

window.EmailUnverifiedTxtid = "Email Belum Diverifikasi";
window.EmailUnverifiedTxten = "Email Unverified";

window.NotMemberTxtid = "Bukan Member";
window.NotMemberTxten = "Not Member";

window.AccountNonActiveTxtid = "Akun Tidak Aktif";
window.AccountNonActiveTxten = "Account Non-Active";

window.YourFriendAccountNotVerifiedTxtid = "Akun Temanmu Belum Terverifikasi";
window.YourFriendAccountNotVerifiedTxten = "Your Friend's Account Has Not Been Verified";

window.YouAccountNotVerifiedTxtid = "Akunmu Belum Terverifikasi";
window.YouAccountNotVerifiedTxten = "Your Account Has Not Been Verified";

window.IDReferralInvalidTxtid = "Kode referral tidak valid. Cek lagi ya";
window.IDReferralInvalidTxten = "ID Referral Invalid";


window.DetermineErrorReferralTxt = function(value)
{
    if(value == "Silakan Input ID Referral Akun yang Registrasi Sebelum Akunmu!")
    {
        return window["PleaseInputAccountThatRegisteredBeforeYouTxt" + window.CurrentCountryID];
    }
    else if(value == "Email Unverified")
    {
        return window["EmailUnverifiedTxt" + window.CurrentCountryID];
    }
    else if(value == "Not Member")
    {
        return window["NotMemberTxt" + window.CurrentCountryID];
    }
    else if(value == "Account Non-Active")
    {
        return window["AccountNonActiveTxt" + window.CurrentCountryID];
    }
    else if(value == "Akun Temanmu Belum Terverifikasi")
    {
        return window["YourFriendAccountNotVerifiedTxt" + window.CurrentCountryID];
    }
    else if(value == "Akunmu Belum Terverifikasi")
    {
        return window["YouAccountNotVerifiedTxt" + window.CurrentCountryID];
    }
    else if(value == "ID Referral Invalid")
    {
        return window["IDReferralInvalidTxt" + window.CurrentCountryID];
    }
    else if(value == "Already used" || value == "Referral already used")
    {
        return window["YourReferralAlreadyUsedorInvalidTxt" + window.CurrentCountryID];
    }
    else
    {
        return window["WarningReferralFailedTxt" + window.CurrentCountryID];
    }
}


// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! VOUCHER PAGE !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

window.DeskripsiVoucTxtid = "Deskripsi Voucher";
window.DeskripsiVoucTxten = "Voucher Description";

window.DeskripsiVoucTxtid = "Deskripsi Voucher";
window.DeskripsiVoucTxten = "Voucher Description";

window.HowtoUseTxtid = "Cara Pakai";
window.HowtoUseTxten = "How to Use";

window.HowToUsein_app =
[
    {
        "id": "Masuk ke halaman <a class='InterBoldItalicTextFont HyperlinkUnderlineText' href='/vouchermenu' style='color: #2494D9 !important;'>Voucher Saya</a> dan pilih voucher.",
        "en": "Go to the <a class='InterBoldItalicTextFont HyperlinkUnderlineText' href='/vouchermenu' style='color: #2494D9 !important;'>My Vouchers</a> page and select a voucher."
    },
    {
        "id": "Salin kode voucher yang kamu pilih",
        "en": "Copy the voucher code you choose"
    },
    {
        "id": "Cari tanggal dan akomodasi yang kamu inginkan",
        "en": "Search for your desired dates and accommodation"
    },
    {
        "id": "Masukkan kode voucher di detail transaksi lalu apply voucher",
        "en": "Enter the voucher code in the transaction details then apply the voucher."
    },
    {
        "id": "Jika Voucher berhasil di gunakan tombol apply akan berubah menjadi hijau",
        "en": "If the voucher is successfully used, the apply button will turn green."
    },
];

window.HowToUsepartner =
[
    {
        "id": "Setelah kamu melakukan penukaran poin, maka CS PinginGo akan memproses penukaran.",
        "en": "After you exchange points, PinginGo CS will process the exchange."
    },
    {
        "id": "Masuk ke halaman <a class='InterBoldItalicTextFont HyperlinkUnderlineText' href='/vouchermenu' style='color: #2494D9 !important;'>Voucher Saya</a> dan pilih voucher partner",
        "en": "Go to the page <a class='HyperlinkUnderlineText' href='/vouchermenu' style='color: #2494D9 !important;'>My Voucher</a> and select the voucher partner"
    },
    {
        "id": "Hubungi CS untuk penukaran voucher, dan CS akan memberikan code voucher untuk bisa dipakai di aplikasi blu.",
        "en": "Contact CS to exchange the voucher, and CS will provide a voucher code that can be used in the Blu application."
    },
];

window.HowToUsegift =
[
    {
        "id": "Masuk ke halaman <a class='InterBoldItalicTextFont HyperlinkUnderlineText' href='/vouchermenu' style='color: #2494D9 !important; '>Voucher Saya</a> dan pilih rewards",
        "en": "Go to the page <a class='InterBoldItalicTextFont HyperlinkUnderlineText' href='/vouchermenu' style='color: #2494D9 !important;'>My Voucher</a> and select rewards"
    },
    {
        "id": "Buka rewards yang ingin ditukar",
        "en": "Open the rewards you want to exchange"
    },
    {
        "id": "Hubungi CS untuk melengkapi alamat pengiriman dan verifikasi",
        "en": "Contact CS to complete the shipping address and verification"
    },
];

window.SalinKodeVoucTxtid = "Salin Kode Voucher";
window.SalinKodeVoucTxten = "Copy Voucher Code";

window.ContactCustomerSerTxtid = "Hubungi Customer Services";
window.ContactCustomerSerTxten = "Contact Customer Services";

window.VoucherThatLoadNotExistTxtid = "Voucher yang Anda coba muat tidak valid.";
window.VoucherThatLoadNotExistTxten = "The Voucher that you are attempting to load is not valid.";

// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! ABOUT US !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

window.AboutUsTopMessageTxtid = "PinginGo. More ping more discount for you";
window.AboutUsTopMessageTxten = "PinginGo. More ping more discount for you";

window.AboutPinginGoTxtid = "Tentang PinginGo";
window.AboutPinginGoTxten = "About PinginGo";

window.AboutMessage1Txtid = "<a class='InterBoldTextFont' href='pingingo.com'>PinginGo</a> merupakan aplikasi layanan promosi akomodasi yang memberikan kemudahan kepada konsumen untuk memesan kamar secara daring <span class='InterMediumItalicTextFont'>(online)</span> ke berbagai hotel yang bekerjasama dengan Pingingo dengan diskon yang menarik.";
window.AboutMessage1Txten = "<a class='InterBoldTextFont' href='pingingo.com'>PinginGo</a> is an accommodation promotion service application that provides convenience for consumers to book rooms online at various hotels that collaborate with PinginGo, offering attractive discounts.";

window.AboutMessage2Txtid = "PinginGo menerapkan konsep <span class='InterBoldItalicTextFont'>group buying promo</span> <span class='InterMediumItalicTextFont'>(promo jika memesan bersama)</span> dalam artinya mitra hotel akan memberikan diskon yang lebih besar kepada konsumen apabila jumlah pemesan kamar untuk tanggal check-in yang sama dari seluruh pengguna PinginGo mencapai target. Semakin banyak konsumen yang memesan kamar untuk tanggal yang sama pada hotel yang sama, maka promo diskon yang ditawarkan akan semakin besar.";
window.AboutMessage2Txten = "PinginGo applies a <span class='InterBoldItalicTextFont'>group buying promo</span> <span class='InterMediumItalicTextFont'>(a promotion applied when booking together)</span>, meaning that partner hotels will give bigger discounts to consumers when the total number of room bookings for the same check-in date made by all PinginGo users reaches a certain target. The more consumers book rooms for the same date at the same hotel, the larger the discount they will receive.";

window.AboutMessage3Txtid = "Pingingo.com merupakan layanan yang diberikan oleh <span class='InterBoldTextFont'>PT PINGINGO BAHAGIA INDONESIA</span>, sebuah badan usaha swasta yang didirikan di Indonesia.";
window.AboutMessage3Txten = "Pingingo.com is a service provided by <span class='InterBoldTextFont'>PT PINGINGO BAHAGIA INDONESIA</span>, a privately owned company established in Indonesia.";

window.AboutMessage4Txtid = "Jika Anda membutuhkan solusi atas kendala dalam mengakses ataumenggunakan aplikasi Pingingo, atau ingin memberikan saran atau masukan untuk perbaikan layanan atau mengajukan kerjasama, Anda dapat menghubungi kami:";
window.AboutMessage4Txten = "If you need assistance accessing or using the PinginGo app, or if you would like to provide feedback for service improvement or propose a partnership, you may contact us:";

// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! CONTACT US !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

window.ContactUsHeaderTxtid = "Hubungi Kami";
window.ContactUsHeaderTxten = "Contact Us";

window.ContactUsMessageTxtid = "Collaborate for Success: Get in Touch Now";
window.ContactUsMessageTxten = "Collaborate for Success: Get in Touch Now";

window.SendUsMsgHeaderTxtid = "Kirim Pesan";
window.SendUsMsgHeaderTxten = "Send us a Message";

window.ContactInformationHeaderTxtid = "Informasi PinginGo";
window.ContactInformationHeaderTxten = "Contact Information";

window.SuccessSendMessageTxtid = "Pesan Anda telah berhasil dikirim! Terima kasih atas pesan Anda, kami akan segera membalasnya.";
window.SuccessSendMessageTxten = "Your message has been successfully sent! Thank you for your message, we will reply to it as soon as possible";

window.ErrorWhenSendingMessageTxtid = "Terjadi kesalahan saat mengirim pesan, silakan coba lagi";
window.ErrorWhenSendingMessageTxten = "An error occurred when sending the message, please try again";

// =============================== DISCOUNT TEXT =========================

window.DiscountTxtid = function(value) { return "Potongan " + value + "%";};
window.DiscountTxten = function(value) { return value + "% Discount";};

window.DiscountTxt2id = function(value) { return "Potongan " + value + "%";};
window.DiscountTxt2en = function(value) { return "Disc " + value + "%";};

window.DiscountWithMaxTxtid = function(discval, discmax)
{
    let ValueToReturn = "Potongan Menginap " + discval + "%";
    if(discmax != null)
    {
        ValueToReturn = ValueToReturn + " Hingga " + window.ConvertTextToRP(discmax, 1, true, false);
    }

    return ValueToReturn;
}
window.DiscountWithMaxTxten = function(discval, discmax)
{
    let ValueToReturn = discval + "% Off Stays";
    if(discmax != null)
    {
        ValueToReturn = ValueToReturn + " Up To " + window.ConvertTextToRP(discmax, 1, true, false);
    }

    return ValueToReturn;
}

window.NoMaxDiscountTxtid = "Tidak ada diskon maks";
window.NoMaxDiscountTxten = "No max discount";

// =============================== LEFT =========================

window.HowManyLeftTxtid = function(value) { return "Sisa " + value;};
window.HowManyLeftTxten = function(value) { return value + " Left";};


// =============================== EDIT PROFILE IMAGE ========================

window.EditProfileImageTxtid = "Edit Gambar Profil";
window.EditProfileImageTxten = "Edit Profile Image";

window.ClickHereorDropImageFileHereTxtid = "Klik di sini atau letakkan file gambar di sini";
window.ClickHereorDropImageFileHereTxten = "Click here or drop image file here";

window.UploadImageTxtid = "Unggah Gambar";
window.UploadImageTxten = "Upload Image";

window.ResetTxtid = "Reset";
window.ResetTxten = "Reset";

window.RemoveTxtid = "Hapus";
window.RemoveTxten = "Remove";

window.DoneAdjustingMessageTxtid = "Selesai menyesuaikan? Terapkan pengaturan pemotongan Anda di sini";
window.DoneAdjustingMessageTxten = "Done adjusting? apply your crop settings here";

window.ApplyCropTxtid = "Terapkan Potongan";
window.ApplyCropTxten = "Apply Crop";

window.CropSuccessHeaderTxtid = "Gambar Berhasil Dipotong!";
window.CropSuccessHeaderTxten = "Crop Success!";

window.ChangeImageTxtid = "Ubah Gambar";
window.ChangeImageTxten = "Change Image";

window.AddImageTxtid = "Tambahkan Gambar";
window.AddImageTxten = "Add Image";

window.ImageUrlTxtid = "Url Gambar";
window.ImageUrlTxten = "Image Url";

window.ErrorUploadingImageMessTxtid = "Kesalahan Mengunggah Gambar";
window.ErrorUploadingImageMessTxten = "Error Uploading Image";

window.ClickSaveButtonToApplyTxtid = "Klik tombol <span class='InterBoldTextFont'>Simpan</span> untuk menerapkan perubahan";
window.ClickSaveButtonToApplyTxten = "Click <span class='InterBoldTextFont'>Save</span> button to apply the changes";

window.FileNotValidOrSizeInsufficientTxtid = "File yang dipilih tidak valid atau memiliki ukuran 0 KB.";
window.FileNotValidOrSizeInsufficientTxten = "The selected file is invalid or has a size of 0 KB.";
// window["" + window.CurrentCountryID]

// ============================================ LISTING MITRA SECTION =============================

// Section 1 -----------------------

window.DaftarkanHeaderTextTopTxtid = "Daftarkan<br>Akomodasi Anda<br>di <span class='TextBlueHighlighted'>PinginGo</span>";
window.DaftarkanHeaderTextTopTxten = "List Your<br>Accommodation<br>on <span class='TextBlueHighlighted'>PinginGo</span>";

window.TopMessageListingMitraTxtid = "Dan Tampilkan Keindahan Alam dari Penginapan Anda: Raih Kesempatan Terbaik sebagai Hidden Gem atau Glamping, Villa, Resort yang Menawarkan Pengalaman Menginap Tak Terlupakan bagi Para Pengunjung.";
window.TopMessageListingMitraTxten = "And Showcase the Natural Beauty of Your Accommodation: Grab the Best Opportunity as a Hidden Gem or Glamping, Villa, Resort that Offers an Unforgettable Stay Experience for Visitors.";

// Section 2 -----------------------

window.TentangTxtid = "Tentang";
window.TentangTxten = "About";

window.Message1Section2Txtid = "Sebagai Online Platform yang berfokus memasarkan dan mempromosikan akomodasi yang bertema <span class='InterExBoldTextFont'>“Beauty of Nature”</span> dan <span class='InterExBoldTextFont'>“Unique Accomodation”</span> dengan menggunakan <span class='InterExBoldTextFont'>Program Terbaik PinginGo</span>.";
window.Message1Section2Txten = "As an online platform focused on marketing and promoting accommodations with the themes of <span class='InterExBoldTextFont'>“Beauty of Nature”</span> and <span class='InterExBoldTextFont'>“Unique Accommodation”</span> through the use of <span class='InterExBoldTextFont'>PinginGo’s Best Program</span>.";

window.Message2Section2Txtid = "PinginGo membantu para pecinta perjalanan dari anak muda hingga dewasa menemukan penginapan bertema Beauty of Nature, Unique Accommodation, dan Hidden Gem di seluruh Indonesia. Seiring tren staycation yang semakin diminati, kami hadir untuk mempermudah pencarian akomodasi yang memikat dan tak terlupakan.";
window.Message2Section2Txten = "PinginGo helps travel enthusiasts, from young to old, find accommodations themed Beauty of Nature, Unique Accommodations, and Hidden Gems throughout Indonesia. As the staycation trend continues to grow, we're here to make it easier to find captivating and unforgettable accommodations.";

// Section 3 -----------------------

window.ChooseTxtid = "Memilih";
window.ChooseTxten = "Choose";

window.BecomeYourPartnerTxtid = "Menjadi Partner Anda";
window.BecomeYourPartnerTxten = "as your partner";

window.ReasonHeader1Section3Txtid = "Pendaftaran Yang Mudah";
window.ReasonHeader1Section3Txten = "Easy Registration";
window.ReasonMessage1Section3Txtid = "Kenyamanan saat mendaftar adalah prioritas kami, daftar secara mudah dan cepat dan di bantu oleh Customer Service PinginGo.";
window.ReasonMessage1Section3Txten = "Your convenience during registration is our priority, register easily and quickly and be assisted by PinginGo Customer Service.";

window.ReasonHeader2Section3Txtid = "Pemasaran yang luas";
window.ReasonHeader2Section3Txten = "Extensive marketing";
window.ReasonMessage2Section3Txtid = "Bergabung dengan PinginGo berarti penginapan Anda mendapat dukungan promo dan pemasaran, meningkatkan visibilitas dan reservasi! 🚀✨";
window.ReasonMessage2Section3Txten = "Joining PinginGo means your accommodation gets promotional and marketing support, increasing visibility and bookings! 🚀✨";

window.ReasonHeader3Section3Txtid = "Layanan Bantuan 24 Jam";
window.ReasonHeader3Section3Txten = "24 Hours Support Service";
window.ReasonMessage3Section3Txtid = "PinginGo menyediakan layanan bantuan 24/7, memastikan Anda selalu mendapat dukungan kapan pun dibutuhkan! 🕒📞✨";
window.ReasonMessage3Section3Txten = "PinginGo provides 24/7 support, ensuring you always have support whenever you need it! 🕒📞✨";

window.ReasonHeader4Section3Txtid = "Kemudahan Kelola Akomodasi";
window.ReasonHeader4Section3Txten = "Easy Accommodation Management";
window.ReasonMessage4Section3Txtid = "Mitra dapat dengan mudah mengatur harga dan ketersediaan kamar, menyesuaikan permintaan pelanggan, serta mengoptimalkan pendapatan dan promosi. Fleksibilitas ini membuat pengelolaan penginapan lebih efisien dan responsif! 💼🏨✨";
window.ReasonMessage4Section3Txten = "Partners can easily manage room rates and availability, adapt to customer demand, and optimize revenue and promotions. This flexibility makes lodging management more efficient and responsive! 💼🏨✨";

window.ReasonHeader5Section3Txtid = "Transaksi Aman";
window.ReasonHeader5Section3Txten = "Safe Transactions";
window.ReasonMessage5Section3Txtid = "Sistem transaksi kami yang aman dan tepercaya memastikan mitra bisa fokus menjalankan bisnis tanpa khawatir. Keamanan dan kenyamanan Anda adalah prioritas kami! 🔒💳😊";
window.ReasonMessage5Section3Txten = "Our secure and trusted transaction system ensures partners can focus on running their businesses without worry. Your safety and comfort are our priority! 🔒💳😊";


// Section 4 -----------------------

window.Section4HeaderTxtid = "Jelajahi Keajaiban Alam dengan Penginapan Indah PinginGo";
window.Section4HeaderTxten = "Explore Natural Wonders with PinginGo's Beautiful Accommodation";

window.Section4MessageTxtid = "Kami menerima berbagai jenis akomodasi seperti Glamping, Camp Ground, Resort, Villa, Hotel, dan lainnya. 🌟🏕️🏡";
window.Section4MessageTxten = "We accept various types of accommodations such as glamping, camping, resorts, villas, hotels, and more. 🌟🏕️🏡";

// Section 5 -----------------------

window.Section5HeaderTxtid = "Dukungan perbankan untuk renovasi.";
window.Section5HeaderTxten = "Banking support for renovation.";

window.Section5MessageTxtid = "Kerjasama antara Pingingo dan lembaga perbankan untuk mendukung pembiayaan renovasi hotel adalah inisiatif strategis yang dapat memberikan manfaat yang signifikan bagi semua pihak yang terlibat. Renovasi hotel merupakan langkah penting untuk meningkatkan kualitas pelayanan, menarik lebih banyak tamu, dan memastikan hotel tetap kompetitif dalam industri perhotelan yang kompetitif.";
window.Section5MessageTxten = "The collaboration between Pingingo and banking institutions to support hotel renovation financing is a strategic initiative that can provide significant benefits for all parties involved. Hotel renovation is a crucial step to improve service quality, attract more guests, and ensure the hotel remains competitive in the competitive hospitality industry.";

// Section 6 -----------------------

window.Section6HeaderTxtid = "Program dan Fitur Kami";
window.Section6HeaderTxten = "Our Program & Features";

window.OurProgram1HeaderTxtid = "Referral<br>Rewards";
window.OurProgram1HeaderTxten = "Referral<br>Rewards";
window.OurProgram1MessageTxtid = "Program utama dari PinginGo yang akan membantu meningkatkan awareness dan visibilitas Anda! Ketika para pengguna membagikan dan melakukan booking di penginapan Anda, mereka akan mendapatkan poin yang bisa ditukarkan dengan voucher, hadiah langsung, dan nginap gratis. Ini akan mendorong pengguna untuk berlomba-lomba membagikan penginapan Anda dan meningkatkan transaksi booking! 🚀🏨🎁";
window.OurProgram1MessageTxten = "PinginGo’s main program is designed to help boost your awareness and visibility! When users share and book a stay at your accommodation, they’ll earn points that can be redeemed for vouchers, instant prizes, and free stays. This encourages users to eagerly share your property and increase booking transactions! 🚀🏨🎁";

window.OurProgram2HeaderTxtid = "Nginep Gratis di PinginGo";
window.OurProgram2HeaderTxten = "Free Stay at PinginGo";
window.OurProgram2MessageTxtid = "Mau user bisa nginep gratis di penginapanmu? Gampang banget caranya! User tinggal share penginapan dan ajak teman serta keluarganya buat nginep di sana. Selain itu, user juga bisa dapetin poin yang bisa dituker dengan Voucher Nginap Gratis. Yuk, ajak lebih banyak orang dan nikmati keuntungannya! 🌟🏨✨";
window.OurProgram2MessageTxten = "Want users to stay at your accommodation for free? It's super easy! Simply share your accommodation and invite friends and family to stay there. Plus, users can earn points that can be redeemed for free stay vouchers. Invite more people and enjoy the benefits! 🌟🏨✨";

window.OurProgram3MessageTxtid = "User bisa mengajak sebanyak banyaknya teman atau keluarganya untuk mengikuti program Ajak Teman Double Cuan. Setiap user berhasil ajak teman untuk join di PinginGo, maka user bisa mendapatkan Poin yang bisa ditukarkan berbagai voucher menginap, menginap gratis dan hadiah langsung dari PinginGo";
window.OurProgram3MessageTxten = "Users can invite as many friends or family as they like to join the 'Invite a Friend Double Cuan' program. Every time a user successfully invites a friend to join PinginGo, they earn points that can be redeemed for various accommodation vouchers, free stays, and prizes directly from PinginGo.";

window.OurProgram4MessageTxtid = "PinginGo mempunyai fitur yang memberikan ruang bagi milenials membagi pengalaman melalui Ping EXPREZY dalam bentuk komen dan foto ala social media. Fitur ini membuat keunikan tempat penginapan Mitra tersebar dan menambah kuat brand mitra.";
window.OurProgram4MessageTxten = "PinginGo has a feature that allows millennials to share their experiences through Ping EXPREZY in the form of social media-style comments and photos. This feature helps spread the word about the uniqueness of Partners' accommodations and strengthens their brand.";

// Section 7 -----------------------

window.Section7HeaderTxtid = "Daftar Akomodasi Dengan Mudah";
window.Section7HeaderTxten = "Easily List Accommodations";

window.Section7Hint1HeaderTxtid = "Daftar Akomodasi";
window.Section7Hint1HeaderTxten = "Register Your Accommodation";
window.Section7Hint1MessageTxtid = "Isi form registrasi yang diberikan oleh CS PinginGo";
window.Section7Hint1MessageTxten = "Fill out the registration form provided by PinginGo’s Customer Service team.";

window.Section7Hint2HeaderTxtid = "Listing Akomodasimu";
window.Section7Hint2HeaderTxten = "List Your Accommodation";
window.Section7Hint2MessageTxtid = "Tambahkan informasi general, rooms dan upload gambar untuk akomodasimu di <span class='InterBoldTextFont'>Mitra PinginGo</span>";
window.Section7Hint2MessageTxten = "Add general information, room details, and upload photos of your accommodation on the <span class='InterBoldTextFont'>Mitra PinginGo Page</span>.";

window.Section7Hint3HeaderTxtid = "Atur Harga & Ketersedian Kamar";
window.Section7Hint3HeaderTxten = "Set Prices & Room Availability";
window.Section7Hint3MessageTxtid = "Atur harga dan ketersidaan kamar untuk akomodasi anda di <span class='InterBoldTextFont'>Mitra PinginGo</span>";
window.Section7Hint3MessageTxten = "Manage your accommodation’s pricing and room availability directly through the <span class='InterBoldTextFont'>Mitra PinginGo Page</span>.";

window.Section7Hint4HeaderTxtid = "Kamu Selesai!";
window.Section7Hint4HeaderTxten = "You’re All Set!";
window.Section7Hint4MessageTxtid = "CS akan verifikasi akomodasi kamu, akomodasi kamu akan segera live di PinginGo";
window.Section7Hint4MessageTxten = "Our Customer Service team will verify your accommodation, and once approved, your listing will go live on PinginGo.";

// Section 8 -----------------------

window.Section8HeaderTxtid = "Atur akomodasi anda dengan CMS Mitra";
window.Section8HeaderTxten = "Manage your accommodation with CMS Mitra";

window.Section8Hint1HeaderTxtid = "Satu Tools Untuk Semua Akomodasimu";
window.Section8Hint1HeaderTxten = "One Tool For All Your Accommodations";
window.Section8Hint1MessageTxtid = "CMS PinginGo Mitra adalah alat yang dirancang khusus untuk membantu Mitra PinginGo dalam mengelola akomodasi mereka, baik itu satu akomodasi (single) maupun beberapa akomodasi (multiple)";
window.Section8Hint1MessageTxten = "PinginGo Partner CMS is a tool specifically designed to help PinginGo Partners manage their accommodation, whether it is one accommodation (single) or several accommodations (multiple).";

window.Section8Hint2HeaderTxtid = "Mengatur harga dan ketersediaan secara fleksibel";
window.Section8Hint2HeaderTxten = "Set prices and availability flexibly";
window.Section8Hint2MessageTxtid = "Sesuaikan harga dan jadwal ketersediaan dengan fleksibel dalam hitungan menit. Pastikan akomodasi selalu siap menerima tamu dengan harga terbaik yang kompetitif.";
window.Section8Hint2MessageTxten = "Adjust your prices and availability flexibly in minutes. Ensure your accommodation is always ready to welcome guests at the best, most competitive rates.";

window.Section8Hint3HeaderTxtid = "Kelola allotment & diskon untuk menarik lebih banyak tamu";
window.Section8Hint3HeaderTxten = "Manage allotments & discounts to attract more guests";
window.Section8Hint3MessageTxtid = "Tentukan kuota kamar dan buat promo menarik untuk meningkatkan tingkat hunian. Strategi diskon yang tepat dapat membantu menarik lebih banyak tamu dan meningkatkan pendapatan.";
window.Section8Hint3MessageTxten = "Set room quotas and create attractive promotions to increase occupancy rates. The right discount strategy can help attract more guests and increase revenue.";

window.Section8Hint4HeaderTxtid = "Pantau performa akomodasi lewat dashboard informatif";
window.Section8Hint4HeaderTxten = "Monitor accommodation performance through an informative dashboard";
window.Section8Hint4MessageTxtid = "Dapatkan insight lengkap mengenai performa akomodasi melalui dashboard interaktif. Analisis tren pemesanan dan optimalkan strategi pemasaran untuk hasil yang lebih maksimal.";
window.Section8Hint4MessageTxten = "Gain comprehensive insights into your accommodation's performance through an interactive dashboard. Analyze booking trends and optimize your marketing strategy for maximum results.";

window.Section8Hint5HeaderTxtid = "Kelola pemesanan & transaksi dengan lebih mudah 🚀";
window.Section8Hint5HeaderTxten = "Manage orders and transactions more easily 🚀";
window.Section8Hint5MessageTxtid = "Semua pemesanan dan transaksi bisa dikelola dalam satu platform, dari konfirmasi booking hingga pembayaran. Proses lebih cepat, tamu lebih puas, dan operasional jadi lebih lancar! 🚀";
window.Section8Hint5MessageTxten = "All bookings and transactions can be managed within a single platform, from booking confirmation to payment. This results in faster processing, happier guests, and smoother operations! 🚀";

window.Section8Hint6HeaderTxtid = "Setup Akomodasi dengan Mudah";
window.Section8Hint6HeaderTxten = "Easy Accommodation Setup";
window.Section8Hint6MessageTxtid = "Tambahkan dan kelola akomodasi dalam beberapa langkah sederhana. Unggah foto, lengkapi detail fasilitas, dan atur harga tanpa ribet.";
window.Section8Hint6MessageTxten = "Add and manage accommodations in a few simple steps. Upload photos, complete facility details, and set prices without the hassle.";


// Section 8.5 -----------------------

window.Section85MessageTxtid = "🌿 Bergabunglah dengan PinginGo dan Jadilah Akomodasi Pilihan! ✨";
window.Section85MessageTxten = "🌿 Join PinginGo and Become a Top Accommodation Choice! ✨";

window.Section85DaftarkanButtonTxtid = "Daftarkan Akomodasimu di PinginGo";
window.Section85DaftarkanButtonTxten = "List Your Accommodation on PinginGo";


// Section 9 -----------------------

window.Section9HeaderTxtid = "PinginGo Channel Broadcast:";
window.Section9HeaderTxten = "PinginGo Channel Broadcast";

window.Section9MessageTxtid = "Kami membantu memasarkan penginapan Anda melalui berbagai saluran, mulai dari media sosial hingga website. Dengan strategi yang komprehensif, visibilitas meningkat dan jumlah tamu pun bertambah! 📈🏨";
window.Section9MessageTxten = "We help promote your accommodation across multiple channels — from social media to websites. With a comprehensive strategy, your visibility increases and more guests come your way! 📈🏨";

// Section 10 ------------------------

window.Section10InstagramBenefits1Txtid = "Maksimalkan pemasaran akomodasi Anda dengan fitur Channel Broadcast di Instagram!";
window.Section10InstagramBenefits1Txten = "Maximize your accommodation marketing with the Channel Broadcast feature on Instagram!";

window.Section10InstagramBenefits2Txtid = "✅ Update Promo & Diskon langsung ke audiens yang tertarget";
window.Section10InstagramBenefits2Txten = "✅ Update Promos & Discounts directly to the targeted audience";

window.Section10InstagramBenefits3Txtid = "✅ Informasi Real-Time tentang ketersediaan & penawaran eksklusif";
window.Section10InstagramBenefits3Txten = "✅ Real-Time information on availability & exclusive offers";

window.Section10InstagramBenefits4Txtid = "✅ Interaksi Lebih Dekat dengan calon tamu untuk meningkatkan booking";
window.Section10InstagramBenefits4Txten = "✅ Closer interaction with potential guests to increase bookings";

window.Section10InstagramBenefits5Txtid = "Jangkau lebih banyak pelanggan & tingkatkan visibilitas akomodasi Anda! 🚀";
window.Section10InstagramBenefits5Txten = "Reach more customers & increase your accommodation's visibility! 🚀";


window.Section10FacebookBenefits1Txtid = "Tingkatkan eksposur akomodasi Anda dengan Channel Broadcast di Facebook!";
window.Section10FacebookBenefits1Txten = "Boost your accommodation’s exposure with Channel Broadcast on Facebook!";

window.Section10FacebookBenefits2Txtid = "✅ Jangkauan Lebih Luas ke calon tamu potensial";
window.Section10FacebookBenefits2Txten = "✅ Reach a wider audience of potential guests";

window.Section10FacebookBenefits3Txtid = "✅ Update Promo & Ketersediaan secara real-time";
window.Section10FacebookBenefits3Txten = "✅ Share promotions & availability in real time";

window.Section10FacebookBenefits4Txtid = "✅ Interaksi Langsung melalui komentar & pesan";
window.Section10FacebookBenefits4Txten = "✅ Engage directly through comments & messages";

window.Section10FacebookBenefits5Txtid = "Optimalkan pemasaran dan tingkatkan booking dengan PinginGo!";
window.Section10FacebookBenefits5Txten = "Maximize your marketing and increase bookings with PinginGo!";


window.Section10TiktokBenefits1Txtid = "Promosikan akomodasi Anda dengan cara yang lebih fun & engaging di TikTok!";
window.Section10TiktokBenefits1Txten = "Promote your accommodation in a more fun and engaging way on TikTok!";

window.Section10TiktokBenefits2Txtid = "✅ Video Menarik untuk meningkatkan awareness & booking";
window.Section10TiktokBenefits2Txten = "✅ Interesting Videos to increase awareness & bookings";

window.Section10TiktokBenefits3Txtid = "✅ Tren & Challenge agar lebih viral di kalangan traveler";
window.Section10TiktokBenefits3Txten = "✅ Trends and Challenges to become more viral among travelers";

window.Section10TiktokBenefits4Txtid = "✅ Interaksi Langsung lewat live & komentar";
window.Section10TiktokBenefits4Txten = "✅ Direct interaction via live & comments";

window.Section10TiktokBenefits5Txtid = "Buat akomodasi Anda makin dikenal & dicari di TikTok! 🔥 #PinginGo";
window.Section10TiktokBenefits5Txten = "Make your accommodation more known and sought after on TikTok! 🔥 #PinginGo";


window.Section10BlogPinginGoBenefits1Txtid = "Blog PinginGo bukan sekadar artikel, tapi juga strategi pemasaran untuk meningkatkan visibilitas dan booking akomodasi Anda!";
window.Section10BlogPinginGoBenefits1Txten = "PinginGo Blog is not just articles, but also a marketing strategy to increase your visibility and accommodation bookings!";

window.Section10BlogPinginGoBenefits2Txtid = "✅ Eksposur Lebih Luas - Akomodasi Anda bisa masuk dalam artikel rekomendasi & panduan wisata.";
window.Section10BlogPinginGoBenefits2Txten = "✅ Wider Exposure - Your accommodation can be included in recommended articles & travel guides.";

window.Section10BlogPinginGoBenefits3Txtid = "✅ SEO & Traffic - Muncul di pencarian Google, menarik calon tamu yang mencari referensi perjalanan.";
window.Section10BlogPinginGoBenefits3Txten = "✅ SEO & Traffic - Appear in Google searches, attracting potential guests looking for travel references.";

window.Section10BlogPinginGoBenefits4Txtid = "✅ Konten Berkualitas - Dibuat dengan storytelling menarik agar lebih engaging & dipercaya traveler.";
window.Section10BlogPinginGoBenefits4Txten = "✅ Quality Content - Created with engaging storytelling to be more engaging & trusted by travelers.";

window.Section10BlogPinginGoBenefits5Txtid = "✅ Promosi Gratis - Liputan khusus tanpa biaya tambahan untuk meningkatkan awareness.";
window.Section10BlogPinginGoBenefits5Txten = "✅ Free Promotion - Special coverage at no additional cost to increase awareness.";


window.Section10CrowdSharingBenefits1Txtid = "Ping and Share membantu akomodasi Anda lebih dikenal & laris!";
window.Section10CrowdSharingBenefits1Txten = "Pink and Share helps your accommodation become more known and popular!";

window.Section10CrowdSharingBenefits2Txtid = "✅ Pemasaran Gratis - Dibagikan tanpa biaya tambahan.";
window.Section10CrowdSharingBenefits2Txten = "✅ Free Marketing - Shared at no additional cost.";

window.Section10CrowdSharingBenefits3Txtid = "✅ Jangkauan Luas - Tersebar di media sosial & komunitas traveler.";
window.Section10CrowdSharingBenefits3Txten = "✅ Wide Reach - Spread across social media and traveler communities.";

window.Section10CrowdSharingBenefits4Txtid = "✅ Lebih Banyak Booking - Semakin sering dibagikan, makin tinggi peluang pemesanan.";
window.Section10CrowdSharingBenefits4Txten = "✅ More Bookings - The more you share, the higher the chance of bookings.";

window.Section10CrowdSharingBenefits5Txtid = "✅ Efek Viral - Rekomendasi pengguna meningkatkan visibilitas.";
window.Section10CrowdSharingBenefits5Txten = "✅ Viral Effect - User recommendations increase visibility.";

window.Section10CrowdSharingBenefits6Txtid = "Promosi effortless, booking maksimal! 🔥🏡 #PinginGo";
window.Section10CrowdSharingBenefits6Txten = "Effortless promotion, maximum bookings! 🔥🏡 #PinginGo";


// Section 11 ------------------------

window.Section11Messsage1Txtid = "🌟 Ayo Gabung dengan PinginGo & Maksimalkan Booking Akomodasi Anda! 🚀";
window.Section11Messsage1Txten = "🌟 Join PinginGo & Maximize Your Accommodation Bookings! 🚀";

window.Section11Messsage2Txtid = "Daftar cepat tanpa biaya awal dan dapatkan eksposur lebih luas melalui berbagai saluran pemasaran. Atur harga, ketersediaan, dan pemesanan dalam satu dashboard yang praktis.";
window.Section11Messsage2Txten = "Sign up quickly with no initial fees and gain wider exposure through multiple marketing channels. Manage pricing, availability, and bookings in one convenient dashboard.";

window.Section11Messsage3Txtid = "🌿 Bergabunglah dengan PinginGo dan Jadilah Akomodasi Pilihan! ✨";
window.Section11Messsage3Txten = "🌿 Join PinginGo and Become the Accommodation of Choice! ✨";


// Join Bermitra ====================================================

window.HelloMitraPinginGoTxtid = "Halo, Mitra PinginGo!";
window.HelloMitraPinginGoTxten = "Hello, Mitra PinginGo!";


window.AccommodationTypeListingTxt =
[
    {
        "type_name":
        {
            "id":"Glamping",
            "en":"Glamping",
        },
        "type_selected":"Glamping",
        "image_url":"/Assets/ListingAssets/MitraTypeChoiceImage/Glamping.png",
        "description":
        {
            "id":"Glamping (glamorous camping) adalah camping nyaman dengan fasilitas mewah, tanpa repot bawa tenda! ⛺✨",
            "en":"Glamping (glamorous camping) is comfortable camping with luxurious facilities, without the hassle of bringing a tent! ⛺✨"
        }
    },
    {
        "type_name":
        {
            "id":"Camp Ground",
            "en":"Camp Ground",
        },
        "type_selected":"Camp Ground",
        "image_url":"/Assets/ListingAssets/MitraTypeChoiceImage/Camp_Ground.png",
        "description":
        {
            "id":"Campground menyediakan area camping yang bisa disewa untuk pengalaman berkemah yang seru dan nyaman.",
            "en":"The campground provides camping areas that can be rented for a fun and comfortable camping experience."
        }
    },
    {
        "type_name":
        {
            "id":"Resort",
            "en":"Resort",
        },
        "type_selected":"Ressort",
        "image_url":"/Assets/ListingAssets/MitraTypeChoiceImage/Ressort.png",
        "description":
        {
            "id":"PinginGo Resort menyewakan penginapan eksklusif di alam dengan fasilitas lengkap untuk liburan nyaman dan berkesan! 🌿🏡✨",
            "en":"PinginGo Resort offers exclusive accommodations in the heart of nature with complete amenities for a comfortable and memorable vacation! 🌿🏡✨"
        }
    },
    {
        "type_name":
        {
            "id":"Villa",
            "en":"Villa",
        },
        "type_selected":"",
        "image_url":"/Assets/ListingAssets/MitraTypeChoiceImage/Villa.png",
        "description":
        {
            "id":"PinginGo Villa menyewakan villa eksklusif dengan suasana alam dan fasilitas lengkap untuk liburan nyaman dan private! 🌿🏡✨",
            "en":"PinginGo Villa rents exclusive villas with natural surroundings and complete facilities for a comfortable and private vacation! 🌿🏡✨"
        }
    },
    {
        "type_name":
        {
            "id":"Hotels",
            "en":"Hotels",
        },
        "type_selected":"Hotels",
        "image_url":"/Assets/ListingAssets/MitraTypeChoiceImage/Hotels.png",
        "description":
        {
            "id":"PinginGo Hotel menyewakan kamar hotel nyaman dengan fasilitas lengkap, cocok untuk liburan atau perjalanan bisnis! 🏨✨",
            "en":"PinginGo Hotel rents comfortable hotel rooms with complete facilities, perfect for vacations or business trips! 🏨✨"
        }
    },
    {
        "type_name":
        {
            "id":"Cabin",
            "en":"Cabin",
        },
        "type_selected":"",
        "image_url":"/Assets/ListingAssets/MitraTypeChoiceImage/Cabin.png",
        "description":
        {
            "id":"PinginGo Cabin menyewakan kabin nyaman di tengah alam, cocok untuk liburan tenang dengan suasana hangat dan fasilitas lengkap! 🌲🏡✨",
            "en":"PinginGo Cabin rents out cozy cabins amidst nature, perfect for a quiet getaway with a warm atmosphere and complete amenities! 🌲🏡✨"
        }
    }
]

window.OthersTypeChoiceTxtid = "Jenis Lainnya";
window.OthersTypeChoiceTxten = "Others Type";

window.HelloMitraPinginGoTxtid = "Halo, Mitra PinginGo!";
window.HelloMitraPinginGoTxten = "Hello, Mitra PinginGo!";


// Header List -------------------------------------------------------------------

window.BermitraTopMessageTxt1id = "Beri tahu kami jenis akomodasi Anda";
window.BermitraTopMessageTxt1en = "Tell us your accommodation type";

window.BermitraTopMessageTxt2id = "Beri tahu kami nama akomodasi Anda";
window.BermitraTopMessageTxt2en = "Tell us your accommodation name";

window.BermitraTopMessageTxt3id = "Lokasi akomodasi Anda";
window.BermitraTopMessageTxt3en = "Your accommodation location";

window.BermitraTopMessageTxt4id = "Tunjukkan foto dan media sosial akomodasi Anda";
window.BermitraTopMessageTxt4en = "Show us your accommodation photos and social media";

window.BermitraTopMessageTxt5id = "Beri tahu kami jumlah kamar dan tarifnya";
window.BermitraTopMessageTxt5en = "Tell us your total rooms and rates";

window.BermitraTopMessageTxt6id = "Profil Anda";
window.BermitraTopMessageTxt6en = "Your Profile";

// --------------------------------------------------------------------

window.AccommodationNameSampleTxtid = "Misalnya: Luxury Glalmping";
window.AccommodationNameSampleTxten = "e.g. Luxury Glalmping";


window.ProvinceTxtid = "Provinsi"; // Province --------------
window.ProvinceTxten = "Province";

window.ProvinceCannotEmptyTxtid = "Provinsi tidak boleh Kosong";
window.ProvinceCannotEmptyTxten = "Province cannot be empty";


window.CityRegionTxtid = "Wilayah Kota"; // City Region --------------
window.CityRegionTxten = "City Region";

window.CityRegionCannotEmptyTxtid = "City Region tidak boleh Kosong";
window.CityRegionCannotEmptyTxten = "City Region cannot be empty";


window.FullAddressTxtid = "Alamat Lengkap"; // Full Address --------------
window.FullAddressTxten = "Full Address";

window.FullAddressPlaceholderTxtid = "Masukkan alamat lengkap akomodasi";
window.FullAddressPlaceholderTxten = "Enter accommodation full address";

window.FullAddressCannotEmptyTxtid = "Alamat Lengkap tidak boleh Kosong";
window.FullAddressCannotEmptyTxten = "Full Address cannot be empty";


window.GoogleMapsUrlTxtid = "Tautan Google Maps"; // Google Maps --------------
window.GoogleMapsUrlTxten = "Google Maps Link";

window.GoogleMapsUrlCannotEmptyTxtid = "Tautan Google Maps tidak boleh Kosong";
window.GoogleMapsUrlCannotEmptyTxten = "Google Maps Link cannot be empty";

window.GoogleMapPlaceholderTxtid = "Misalnya: https://maps.app.goo.gl/YP5jR5jGQrymsKWHA";
window.GoogleMapPlaceholderTxten = "eg. https://maps.app.goo.gl/YP5jR5jGQrymsKWHA";


window.AccPhotosTxtid = "Foto Akomodasi"; // Accommodation --------------
window.AccPhotosTxten = "Accommodation Photos";

window.GoogleMapsUrlCannotEmptyTxtid = "Foto Akomodasi tidak boleh Kosong";
window.GoogleMapsUrlCannotEmptyTxten = "Accommodation Photos cannot be empty";


window.AddPhotoRuleAndLimitTxtid = "Tambahkan foto akomodasi Anda di sini, dan Anda dapat mengunggah maksimal 10 file dan minimal 1 foto";
window.AddPhotoRuleAndLimitTxten = "Add your accommodation photos here, and you can upload up to 10 files max and min 1 photo";

window.DragYourFileOrInputTxtid = "Seret file Anda atau <span style='color: #1849D6;' class='HyperlinkUnderlineText'>Telusuri</span>";
window.DragYourFileOrInputTxten = "Drag your file(s) or <span style='color: #1849D6;' class='HyperlinkUnderlineText'>Browse</span>";

window.Max10MBFilesAllowedTxtid = "Ukuran file yang diizinkan maksimal 10 MB";;
window.Max10MBFilesAllowedTxten = "Max 10 MB files are allowed";

window.AccSocialMediaTxtid = "Media Sosial Akomodasi";
window.AccSocialMediaTxten = "Accommodation Social Media";

window.AddYourAccSocialMediaTxtid = "Tambahkan media sosial akomodasi Anda, baik tiktok atau instagram.";
window.AddYourAccSocialMediaTxten = "Add your accommodation social media, either tiktok or instagram.";

window.TotalRoomsTxtid = "Jumlah Kamar";
window.TotalRoomsTxten = "Total Rooms";
window.TotalRoomsCannotEmptyTxtid = "Jumlah Kamar Tidak Boleh Kosong!";
window.TotalRoomsCannotEmptyTxten = "Total Rooms cannot be Empty!";
window.TotalPlaceholderTxtid = "Masukkan jumlah kamar";
window.TotalPlaceholderTxten = "Enter total rooms";
 

window.RoomRatesTxtid = "Tarif Kamar";
window.RoomRatesTxten = "Room Rates";

window.MinRoomRatesCannotEmptyTxtid = "Harga Tarif Kamar Minimum tidak boleh kosong!";
window.MinRoomRatesCannotEmptyTxten = "Min Room Rates Price cannot be empty!";

window.ToTxtid = "sampai";
window.ToTxten = "to";

window.MaxRoomRatesCannotEmptyTxtid = "Harga Tarif Kamar Maksimum tidak boleh kosong!";
window.MaxRoomRatesCannotEmptyTxten = "Max Room Rates Price cannot be empty!";

window.MaxRoomRatesPricesCannotLowerTxtid = "Harga Tarif Kamar Maksimum tidak boleh lebih rendah dari Nilai Minimum!";
window.MaxRoomRatesPricesCannotLowerTxten = "Max Room Rates Price cannot be lower than the Min Value!";

window.DepartmentTxtid = "Departemen";
window.DepartmentTxten = "Department";
window.DepartmentCannotEmptyTxtid = "Departemen tidak boleh kosong!";
window.DepartmentCannotEmptyTxten = "Department cannot be empty!";
window.DepartmentPlaceholderTxtid = "Misalnya: Pemilik, Manajer";
window.DepartmentPlaceholderTxten = "eg. Owner, Manager";

window.ThisPhonehasWATxtid = "Nomor telepon ini memiliki WhatsApp";
window.ThisPhonehasWATxten = "This phone number have WhatsApp";

window.AccommodationSubmittedTxtid = "Akomodasi Berhasil Dikirim";
window.AccommodationSubmittedTxten = "Accommodation Submitted";

window.HelloThankyouForSubmittingAccTxtid = "Halo! Terima kasih telah mengirimkan data akomodasi Anda. Tim kami akan segera menghubungi Anda, dan akomodasi Anda akan segera tampil di platform kami.";
window.HelloThankyouForSubmittingAccTxten = "Hello! Thank you for submitting your accommodation. Our team will contact you shortly, and your accommodation will be listed on our platform soon.";


// ================================ NOT FOUND ==================================

window.PageNotFoundHeaderTxtid = "Halaman Tidak Ditemukan";
window.PageNotFoundHeaderTxten = "Page Not Found";

window.PageNotFoundMessageTxtid = "Link yang kamu tuju mungkin sudah pindah atau dihapus. Yuk, lanjut explore penginapan unik lainnya.";
window.PageNotFoundMessageTxten = "The link you're looking for may have moved or been removed. Let's continue exploring other unique accommodations.";
